export const unitsDictionary: ([string] | [string, string, number, number, number, number])[] = [
  ['%', 'Euc', 0, 0.01, 1, 0],
  ['ppk', 'Euc', 0, 1e-3, 1, 0],
  ['ppm', 'Euc', 0, 1e-6, 1, 0],
  ['Euc'],
  ['byte', 'bit', 0, 8, 1, 0],
  ['bit'],
  ['%[mass]', 'kg/kg', 0, 0.01, 1, 0],
  ['ppm[mass]', 'kg/kg', 0, 1e-6, 1, 0],
  ['%[area]', 'm2/m2', 0, 0.01, 1, 0],
  ['%[vol]', 'm3/m3', 0, 0.01, 1, 0],
  ['ppm[vol]', 'm3/m3', 0, 1e-6, 1, 0],
  ['%[molar]', 'mol/mol', 0, 0.01, 1, 0],
  ['(bbl/d)/(bbl/d)', '(m3/s)/(m3/s)', 0, 1, 1, 0],
  ['(m3/d)/(m3/d)', '(m3/s)/(m3/s)', 0, 1, 1, 0],
  ['1E6 (ft3/d)/(bbl/d)', '(m3/s)/(m3/s)', 0, 28.316846592e3, 0.158987294928, 0],
  ['(m3/s)/(m3/s)'],
  ['kg/kg'],
  ['m/m'],
  ['m2/m2'],
  ['m3/m3'],
  ['mol/mol'],
  ['N/N'],
  ['s/s'],
  ['W/W'],
  ['g/kg', 'kg/kg', 0, 1e-3, 1, 0],
  ['g/t', 'kg/kg', 0, 1e-6, 1, 0],
  ['kg/sack[94lbm]', 'kg/kg', 0, 1, 42.63768278, 0],
  ['kg/t', 'kg/kg', 0, 1e-3, 1, 0],
  ['mg/g', 'kg/kg', 0, 1e-3, 1, 0],
  ['mg/kg', 'kg/kg', 0, 1e-6, 1, 0],
  ['ng/g', 'kg/kg', 0, 1e-9, 1, 0],
  ['ng/mg', 'kg/kg', 0, 1e-6, 1, 0],
  ['ug/g', 'kg/kg', 0, 1e-6, 1, 0],
  ['ug/mg', 'kg/kg', 0, 1e-3, 1, 0],
  ['0.01 ft/ft', 'm/m', 0, 0.01, 1, 0],
  ['1/30 m/m', 'm/m', 0, 1, 30, 0],
  ['ft/ft', 'm/m', 0, 1, 1, 0],
  ['ft/in', 'm/m', 0, 12, 1, 0],
  ['ft/m', 'm/m', 0, 0.3048, 1, 0],
  ['ft/mi', 'm/m', 0, 1, 5280, 0],
  ['km/cm', 'm/m', 0, 1e5, 1, 0],
  ['m/cm', 'm/m', 0, 100, 1, 0],
  ['m/km', 'm/m', 0, 1e-3, 1, 0],
  ['mi/in', 'm/m', 0, 63360, 1, 0],
  ['in2/ft2', 'm2/m2', 0, 1, 144, 0],
  ['in2/in2', 'm2/m2', 0, 1, 1, 0],
  ['mm2/mm2', 'm2/m2', 0, 1, 1, 0],
  ['0.001 bbl/ft3', 'm3/m3', 0, 1.58987294928e-4, 0.028316846592, 0],
  ['0.001 bbl/m3', 'm3/m3', 0, 1.58987294928e-4, 1, 0],
  ['0.001 gal[UK]/bbl', 'm3/m3', 0, 4.54609e-6, 0.158987294928, 0],
  ['0.001 gal[UK]/gal[UK]', 'm3/m3', 0, 1e-3, 1, 0],
  ['0.001 gal[US]/bbl', 'm3/m3', 0, 3.785411784e-6, 0.158987294928, 0],
  ['0.001 gal[US]/ft3', 'm3/m3', 0, 3.785411784e-6, 0.028316846592, 0],
  ['0.001 gal[US]/gal[US]', 'm3/m3', 0, 1e-3, 1, 0],
  ['0.001 pt[UK]/bbl', 'm3/m3', 0, 5.6826125e-4, 158.987294928, 0],
  ['0.01 bbl/bbl', 'm3/m3', 0, 0.01, 1, 0],
  ['0.1 gal[US]/bbl', 'm3/m3', 0, 3.785411784e-4, 0.158987294928, 0],
  ['0.1 L/bbl', 'm3/m3', 0, 0.001, 1.58987294928, 0],
  ['0.1 pt[US]/bbl', 'm3/m3', 0, 4.73176473e-4, 1.58987294928, 0],
  ['1000 ft3/bbl', 'm3/m3', 0, 28.316846592, 0.158987294928, 0],
  ['1000 m3/m3', 'm3/m3', 0, 1e3, 1, 0],
  ['1E-6 acre.ft/bbl', 'm3/m3', 0, 1.911900672e4, 2.464298142777857232e6, 0],
  ['1E6 bbl/(acre.ft)', 'm3/m3', 0, 2.464298142777857232e12, 1.911900672e10, 0],
  ['1E-6 bbl/ft3', 'm3/m3', 0, 0.158987294928, 2.8316846592e4, 0],
  ['1E-6 bbl/m3', 'm3/m3', 0, 1.58987294928e-7, 1, 0],
  ['1E6 ft3/(acre.ft)', 'm3/m3', 0, 1.43999424000576e12, 6.27264e10, 0],
  ['1E6 ft3/bbl', 'm3/m3', 0, 28.316846592e3, 0.158987294928, 0],
  ['bbl/(acre.ft)', 'm3/m3', 0, 2.464298142777857232e6, 1.911900672e10, 0],
  ['bbl/bbl', 'm3/m3', 0, 1, 1, 0],
  ['bbl/ft3', 'm3/m3', 0, 0.158987294928, 0.028316846592, 0],
  ['bbl/m3', 'm3/m3', 0, 0.158987294928, 1, 0],
  ['cm3/cm3', 'm3/m3', 0, 1, 1, 0],
  ['cm3/L', 'm3/m3', 0, 1e-3, 1, 0],
  ['cm3/m3', 'm3/m3', 0, 1e-6, 1, 0],
  ['dm3/m3', 'm3/m3', 0, 1e-3, 1, 0],
  ['ft3/bbl', 'm3/m3', 0, 0.028316846592, 0.158987294928, 0],
  ['ft3/ft3', 'm3/m3', 0, 1, 1, 0],
  ['gal[UK]/ft3', 'm3/m3', 0, 4.54609e-3, 0.028316846592, 0],
  ['gal[US]/bbl', 'm3/m3', 0, 3.785411784e-3, 0.158987294928, 0],
  ['gal[US]/ft3', 'm3/m3', 0, 3.785411784e-3, 0.028316846592, 0],
  ['L/m3', 'm3/m3', 0, 1e-3, 1, 0],
  ['m3/(ha.m)', 'm3/m3', 0, 1e-4, 1, 0],
  ['m3/bbl', 'm3/m3', 0, 1, 0.158987294928, 0],
  ['mL/gal[UK]', 'm3/m3', 0, 1e-6, 4.54609e-3, 0],
  ['mL/gal[US]', 'm3/m3', 0, 1e-6, 3.785411784e-3, 0],
  ['mL/mL', 'm3/m3', 0, 1, 1, 0],
  ['kgf/kgf', 'N/N', 0, 1, 1, 0],
  ['lbf/lbf', 'N/N', 0, 1, 1, 0],
  ['ms/s', 's/s', 0, 1e-3, 1, 0],
  ['Btu[IT]/(hp.h)', 'W/W', 0, 1.05505585262e3, 2.684519537696172792e6, 0],
  ['W/kW', 'W/W', 0, 1e-3, 1, 0],
  ['cEuc', 'Euc', 0, 0.01, 1, 0],
  ['dEuc', 'Euc', 0, 0.1, 1, 0],
  ['EEuc', 'Euc', 0, 1e18, 1, 0],
  ['fEuc', 'Euc', 0, 1e-15, 1, 0],
  ['GEuc', 'Euc', 0, 1e9, 1, 0],
  ['kEuc', 'Euc', 0, 1e3, 1, 0],
  ['mEuc', 'Euc', 0, 1e-3, 1, 0],
  ['MEuc', 'Euc', 0, 1e6, 1, 0],
  ['nEuc', 'Euc', 0, 1e-9, 1, 0],
  ['pEuc', 'Euc', 0, 1e-12, 1, 0],
  ['TEuc', 'Euc', 0, 1e12, 1, 0],
  ['uEuc', 'Euc', 0, 1e-6, 1, 0],
  ['Kibyte', 'bit', 0, 8192, 1, 0],
  ['Mibyte', 'bit', 0, 8388608, 1, 0],
  ['1/deltaC', '1/deltaK', 0, 1, 1, 0],
  ['1/deltaF', '1/deltaK', 0, 9, 5, 0],
  ['1/deltaR', '1/deltaK', 0, 9, 5, 0],
  ['1/deltaK'],
  ['m/(m.deltaK)'],
  ['m3/(m3.deltaK)'],
  ['in/(in.deltaF)', 'm/(m.deltaK)', 0, 9, 5, 0],
  ['mm/(mm.deltaK)', 'm/(m.deltaK)', 0, 1, 1, 0],
  ['1E-6 m3/(m3.deltaC)', 'm3/(m3.deltaK)', 0, 1e-6, 1, 0],
  ['1E-6 m3/(m3.deltaF)', 'm3/(m3.deltaK)', 0, 9e-6, 5, 0],
  ['ppm[vol]/deltaC', 'm3/(m3.deltaK)', 0, 1e-6, 1, 0],
  ['ppm[vol]/deltaF', 'm3/(m3.deltaK)', 0, 9e-6, 5, 0],
  ['cu', 'm2/m3', 0, 0.1, 1, 0],
  ['1/angstrom', '1/m', 0, 1e10, 1, 0],
  ['1/cm', '1/m', 0, 100, 1, 0],
  ['1/ft', '1/m', 0, 1, 0.3048, 0],
  ['1/in', '1/m', 0, 1, 0.0254, 0],
  ['1/mi', '1/m', 0, 1, 1609.344, 0],
  ['1/mm', '1/m', 0, 1e3, 1, 0],
  ['1/nm', '1/m', 0, 1e9, 1, 0],
  ['1/yd', '1/m', 0, 1, 0.9144, 0],
  ['1E-9 1/ft', '1/m', 0, 1e-9, 0.3048, 0],
  ['b/cm3', '1/m', 0, 1e-22, 1, 0],
  ['ft2/in3', '1/m', 0, 0.09290304, 1.6387064e-5, 0],
  ['m2/cm3', '1/m', 0, 1e6, 1, 0],
  ['1/m'],
  ['m2/m3'],
  ['1/ft2', '1/m2', 0, 1, 0.09290304, 0],
  ['1/km2', '1/m2', 0, 1e-6, 1, 0],
  ['1/mi2', '1/m2', 0, 1, 2.589988110336e6, 0],
  ['1/m2'],
  ['m/m3'],
  ['ft/bbl', 'm/m3', 0, 0.3048, 0.158987294928, 0],
  ['ft/ft3', 'm/m3', 0, 1, 0.09290304, 0],
  ['ft/gal[US]', 'm/m3', 0, 0.3048, 0.003785411784, 0],
  ['km/dm3', 'm/m3', 0, 1e6, 1, 0],
  ['km/L', 'm/m3', 0, 1e6, 1, 0],
  ['mi/gal[UK]', 'm/m3', 0, 1609.344, 0.00454609, 0],
  ['mi/gal[US]', 'm/m3', 0, 1609.344, 0.003785411784, 0],
  ['1/bbl', '1/m3', 0, 1, 0.158987294928, 0],
  ['1/ft3', '1/m3', 0, 1, 0.028316846592, 0],
  ['1/gal[UK]', '1/m3', 0, 1, 0.00454609, 0],
  ['1/gal[US]', '1/m3', 0, 1, 0.003785411784, 0],
  ['1/L', '1/m3', 0, 1e3, 1, 0],
  ['1/m3'],
  ['1/g', '1/kg', 0, 1e3, 1, 0],
  ['1/lbm', '1/kg', 0, 1, 0.45359237, 0],
  ['1/kg'],
  ['1/(kg.s)', 'Bq/kg', 0, 1, 1, 0],
  ['pCi/g', 'Bq/kg', 0, 37, 1, 0],
  ['Bq/kg'],
  ['Ci', 'Bq', 0, 3.7e10, 1, 0],
  ['Bd'],
  ['Bq'],
  ['Hz'],
  ['1/a', '1/s', 0, 1, 3.15576e7, 0],
  ['1/d', '1/s', 0, 1, 86400, 0],
  ['1/h', '1/s', 0, 1, 3600, 0],
  ['1/min', '1/s', 0, 1, 60, 0],
  ['1/ms', '1/s', 0, 1e3, 1, 0],
  ['1/us', '1/s', 0, 1e6, 1, 0],
  ['1/wk', '1/s', 0, 1, 6.048e5, 0],
  ['byte/s', 'bit/s', 0, 8, 1, 0],
  ['1/s'],
  ['bit/s'],
  ['m3/(s.m3)'],
  ['bbl/(d.acre.ft)', 'm3/(s.m3)', 0, 2.464298142777857232e6, 1.651882180608e15, 0],
  ['GBq', 'Bq', 0, 1e9, 1, 0],
  ['MBq', 'Bq', 0, 1e6, 1, 0],
  ['mCi', 'Bq', 0, 3.7e7, 1, 0],
  ['nCi', 'Bq', 0, 37, 1, 0],
  ['pCi', 'Bq', 0, 0.037, 1, 0],
  ['TBq', 'Bq', 0, 1e12, 1, 0],
  ['uCi', 'Bq', 0, 3.7e4, 1, 0],
  ['cHz', 'Hz', 0, 0.01, 1, 0],
  ['dHz', 'Hz', 0, 0.1, 1, 0],
  ['EHz', 'Hz', 0, 1e18, 1, 0],
  ['fHz', 'Hz', 0, 1e-15, 1, 0],
  ['GHz', 'Hz', 0, 1e9, 1, 0],
  ['kHz', 'Hz', 0, 1e3, 1, 0],
  ['mHz', 'Hz', 0, 1e-3, 1, 0],
  ['MHz', 'Hz', 0, 1e6, 1, 0],
  ['nHz', 'Hz', 0, 1e-9, 1, 0],
  ['pHz', 'Hz', 0, 1e-12, 1, 0],
  ['THz', 'Hz', 0, 1e12, 1, 0],
  ['uHz', 'Hz', 0, 1e-6, 1, 0],
  ['rad'],
  ['ccgr', 'rad', 0, Math.PI, 2e6, 0],
  ['cgr', 'rad', 0, Math.PI, 2e4, 0],
  ['dega', 'rad', 0, Math.PI, 180, 0],
  ['gon', 'rad', 0, Math.PI, 200, 0],
  ['mila', 'rad', 0, Math.PI, 3.2e3, 0],
  ['mina', 'rad', 0, Math.PI, 1.08e4, 0],
  ['rev', 'rad', 0, 2 * Math.PI, 1, 0],
  ['seca', 'rad', 0, Math.PI, 6.48e5, 0],
  ['0.001 seca', 'rad', 0, Math.PI, 6.48e8, 0],
  ['krad', 'rad', 0, 1e3, 1, 0],
  ['mrad', 'rad', 0, 1e-3, 1, 0],
  ['Mrad', 'rad', 0, 1e6, 1, 0],
  ['urad', 'rad', 0, 1e-6, 1, 0],
  ['rad/m'],
  ['0.01 dega/ft', 'rad/m', 0, Math.PI, 5.4864e3, 0],
  ['1/30 dega/ft', 'rad/m', 0, Math.PI, 1.64592e3, 0],
  ['1/30 dega/m', 'rad/m', 0, Math.PI, 5400, 0],
  ['dega/ft', 'rad/m', 0, Math.PI, 54.864, 0],
  ['dega/m', 'rad/m', 0, Math.PI, 180, 0],
  ['rad/ft', 'rad/m', 0, 1, 0.3048, 0],
  ['rev/ft', 'rad/m', 0, 2 * Math.PI, 0.3048, 0],
  ['rev/m', 'rad/m', 0, 2 * Math.PI, 1, 0],
  ['rad/m3'],
  ['rad/ft3', 'rad/m3', 0, 1, 0.028316846592, 0],
  ['rpm', 'rad/s', 0, 2 * Math.PI, 60, 0],
  ['rad/s'],
  ['dega/h', 'rad/s', 0, Math.PI, 6.48e5, 0],
  ['dega/min', 'rad/s', 0, Math.PI, 1.08e4, 0],
  ['dega/s', 'rad/s', 0, Math.PI, 180, 0],
  ['rev/s', 'rad/s', 0, 2 * Math.PI, 1, 0],
  ['rad/s2'],
  ['rpm/s', 'rad/s2', 0, 2 * Math.PI, 60, 0],
  ['deltaC', 'deltaK', 0, 1, 1, 0],
  ['deltaF', 'deltaK', 0, 5, 9, 0],
  ['deltaR', 'deltaK', 0, 5, 9, 0],
  ['deltaK'],
  ['0.01 deltaF/ft', 'deltaK/m', 0, 5, 274.32, 0],
  ['deltaC/ft', 'deltaK/m', 0, 1, 0.3048, 0],
  ['deltaC/hm', 'deltaK/m', 0, 0.01, 1, 0],
  ['deltaC/km', 'deltaK/m', 0, 1e-3, 1, 0],
  ['deltaC/m', 'deltaK/m', 0, 1, 1, 0],
  ['deltaF/ft', 'deltaK/m', 0, 5, 2.7432, 0],
  ['deltaF/m', 'deltaK/m', 0, 5, 9, 0],
  ['deltaK/km', 'deltaK/m', 0, 1e-3, 1, 0],
  ['deltaK/m'],
  ['deltaC/h', 'deltaK/s', 0, 1, 3600, 0],
  ['deltaC/min', 'deltaK/s', 0, 1, 60, 0],
  ['deltaC/s', 'deltaK/s', 0, 1, 1, 0],
  ['deltaF/h', 'deltaK/s', 0, 5, 3.24e4, 0],
  ['deltaF/min', 'deltaK/s', 0, 5, 540, 0],
  ['deltaF/s', 'deltaK/s', 0, 5, 9, 0],
  ['deltaK/s'],
  ['deltaC/kPa', 'deltaK/Pa', 0, 1e-3, 1, 0],
  ['deltaF/psi', 'deltaK/Pa', 0, 3.2258e-3, 40.0339945373445, 0],
  ['deltaK/Pa'],
  ['deltaK/W'],
  ['deltaC.m2.h/kcal[th]', 'deltaK.m2/W', 0, 3600, 4.184e3, 0],
  ['deltaF.ft2.h/Btu[IT]', 'deltaK.m2/W', 0, 1.67225472e3, 9.49550267358e3, 0],
  ['deltaK.m2/kW', 'deltaK.m2/W', 0, 1e-3, 1, 0],
  ['deltaK.m2/W'],
  ['A'],
  ['cA', 'A', 0, 0.01, 1, 0],
  ['dA', 'A', 0, 0.1, 1, 0],
  ['EA', 'A', 0, 1e18, 1, 0],
  ['fA', 'A', 0, 1e-15, 1, 0],
  ['GA', 'A', 0, 1e9, 1, 0],
  ['kA', 'A', 0, 1e3, 1, 0],
  ['mA', 'A', 0, 1e-3, 1, 0],
  ['MA', 'A', 0, 1e6, 1, 0],
  ['nA', 'A', 0, 1e-9, 1, 0],
  ['pA', 'A', 0, 1e-12, 1, 0],
  ['TA', 'A', 0, 1e12, 1, 0],
  ['uA', 'A', 0, 1e-6, 1, 0],
  ['Oe', 'A/m', 0, 1000, 4 * Math.PI, 0],
  ['A/mm', 'A/m', 0, 1e3, 1, 0],
  ['A/m'],
  ['A/cm2', 'A/m2', 0, 1e4, 1, 0],
  ['A/ft2', 'A/m2', 0, 1, 0.09290304, 0],
  ['A/mm2', 'A/m2', 0, 1e6, 1, 0],
  ['mA/cm2', 'A/m2', 0, 10, 1, 0],
  ['mA/ft2', 'A/m2', 0, 1e-3, 0.09290304, 0],
  ['uA/cm2', 'A/m2', 0, 0.01, 1, 0],
  ['uA/in2', 'A/m2', 0, 1e-6, 6.4516e-4, 0],
  ['A/m2'],
  ['1/H'],
  ['S'],
  ['cS', 'S', 0, 0.01, 1, 0],
  ['dS', 'S', 0, 0.1, 1, 0],
  ['ES', 'S', 0, 1e18, 1, 0],
  ['fS', 'S', 0, 1e-15, 1, 0],
  ['GS', 'S', 0, 1e9, 1, 0],
  ['kS', 'S', 0, 1e3, 1, 0],
  ['mS', 'S', 0, 1e-3, 1, 0],
  ['MS', 'S', 0, 1e6, 1, 0],
  ['nS', 'S', 0, 1e-9, 1, 0],
  ['pS', 'S', 0, 1e-12, 1, 0],
  ['TS', 'S', 0, 1e12, 1, 0],
  ['uS', 'S', 0, 1e-6, 1, 0],
  ['S/m'],
  ['kS/m', 'S/m', 0, 1e3, 1, 0],
  ['mS/cm', 'S/m', 0, 0.1, 1, 0],
  ['mS/m', 'S/m', 0, 1e-3, 1, 0],
  ['F'],
  ['cF', 'F', 0, 0.01, 1, 0],
  ['dF', 'F', 0, 0.1, 1, 0],
  ['EF', 'F', 0, 1e18, 1, 0],
  ['fF', 'F', 0, 1e-15, 1, 0],
  ['GF', 'F', 0, 1e9, 1, 0],
  ['kF', 'F', 0, 1e3, 1, 0],
  ['mF', 'F', 0, 1e-3, 1, 0],
  ['MF', 'F', 0, 1e6, 1, 0],
  ['nF', 'F', 0, 1e-9, 1, 0],
  ['pF', 'F', 0, 1e-12, 1, 0],
  ['TF', 'F', 0, 1e12, 1, 0],
  ['uF', 'F', 0, 1e-6, 1, 0],
  ['uF/m', 'F/m', 0, 1e-6, 1, 0],
  ['F/m'],
  ['A.m2'],
  ['C.m'],
  ['C'],
  ['A.h', 'C', 0, 3600, 1, 0],
  ['A.s', 'C', 0, 1, 1, 0],
  ['cC', 'C', 0, 0.01, 1, 0],
  ['dC', 'C', 0, 0.1, 1, 0],
  ['EC', 'C', 0, 1e18, 1, 0],
  ['fC', 'C', 0, 1e-15, 1, 0],
  ['GC', 'C', 0, 1e9, 1, 0],
  ['kC', 'C', 0, 1e3, 1, 0],
  ['mC', 'C', 0, 1e-3, 1, 0],
  ['MC', 'C', 0, 1e6, 1, 0],
  ['nC', 'C', 0, 1e-9, 1, 0],
  ['pC', 'C', 0, 1e-12, 1, 0],
  ['TC', 'C', 0, 1e12, 1, 0],
  ['uC', 'C', 0, 1e-6, 1, 0],
  ['C/cm2', 'C/m2', 0, 1e4, 1, 0],
  ['C/mm2', 'C/m2', 0, 1e6, 1, 0],
  ['mC/m2', 'C/m2', 0, 1e-3, 1, 0],
  ['C/m2'],
  ['A.s/m3', 'C/m3', 0, 1, 1, 0],
  ['C/cm3', 'C/m3', 0, 1e6, 1, 0],
  ['C/mm3', 'C/m3', 0, 1e9, 1, 0],
  ['C/m3'],
  ['A.s/kg', 'C/kg', 0, 1, 1, 0],
  ['C/g', 'C/kg', 0, 1e3, 1, 0],
  ['C/kg'],
  ['1/uV', '1/V', 0, 1e6, 1, 0],
  ['1/V'],
  ['cd'],
  ['kcd', 'cd', 0, 1e3, 1, 0],
  ['cd/m2'],
  ['lm'],
  ['lx'],
  ['footcandle', 'lx', 0, 1, 0.09290304, 0],
  ['lm/m2', 'lx', 0, 1, 1, 0],
  ['klx', 'lx', 0, 1e3, 1, 0],
  ['lm.s'],
  ['lx.s'],
  ['footcandle.s', 'lx.s', 0, 1, 0.09290304, 0],
  ['lm/W'],
  ['K'],
  ['degC', 'K', 273.15, 1, 1, 0],
  ['degF', 'K', 2298.35, 5, 9, 0],
  ['degR', 'K', 0, 5, 9, 0],
  ['m'],
  ['angstrom', 'm', 0, 1e-10, 1, 0],
  ['chain', 'm', 0, 20.1168, 1, 0],
  ['chain[BnA]', 'm', 0, 20.1167824, 1, 0],
  ['chain[BnB]', 'm', 0, 792, 39.370113, 0],
  ['chain[Cla]', 'm', 0, 20.1166195164, 1, 0],
  ['chain[Ind37]', 'm', 0, 20.11669506, 1, 0],
  ['chain[Se]', 'm', 0, 792, 39.370147, 0],
  ['chain[SeT]', 'm', 0, 20.116756, 1, 0],
  ['chain[US]', 'm', 0, 792, 39.37, 0],
  ['fathom', 'm', 0, 1.8288, 1, 0],
  ['ft', 'm', 0, 0.3048, 1, 0],
  ['ft[BnA]', 'm', 0, 0.9143992, 3, 0],
  ['ft[BnB]', 'm', 0, 12, 39.370113, 0],
  ['ft[Br36]', 'm', 0, 0.3048007491, 1, 0],
  ['ft[Br65]', 'm', 0, 0.9144025, 3, 0],
  ['ft[Cla]', 'm', 0, 0.3047972654, 1, 0],
  ['ft[GC]', 'm', 0, 6378300, 20926201, 0],
  ['ft[Ind]', 'm', 0, 12, 39.370142, 0],
  ['ft[Ind37]', 'm', 0, 0.30479841, 1, 0],
  ['ft[Ind62]', 'm', 0, 0.3047996, 1, 0],
  ['ft[Ind75]', 'm', 0, 0.3047995, 1, 0],
  ['ft[Se]', 'm', 0, 12, 39.370147, 0],
  ['ft[SeT]', 'm', 0, 0.914398, 3, 0],
  ['ft[US]', 'm', 0, 1200, 3937, 0],
  ['fur[US]', 'm', 0, 792000, 3937, 0],
  ['in', 'm', 0, 0.0254, 1, 0],
  ['in[US]', 'm', 0, 100, 3937, 0],
  ['link', 'm', 0, 20.1168, 100, 0],
  ['link[BnA]', 'm', 0, 0.201167824, 1, 0],
  ['link[BnB]', 'm', 0, 7.92, 39.370113, 0],
  ['link[Cla]', 'm', 0, 0.201166195164, 1, 0],
  ['link[Se]', 'm', 0, 7.92, 39.370147, 0],
  ['link[SeT]', 'm', 0, 0.20116756, 1, 0],
  ['link[US]', 'm', 0, 7.92, 39.37, 0],
  ['m[Ger]', 'm', 0, 1.0000135965, 1, 0],
  ['mi', 'm', 0, 1609.344, 1, 0],
  ['mi[naut]', 'm', 0, 1852, 1, 0],
  ['mi[nautUK]', 'm', 0, 1853, 1, 0],
  ['mi[US]', 'm', 0, 6.336e6, 3937, 0],
  ['mil', 'm', 0, 2.54e-5, 1, 0],
  ['rod[US]', 'm', 0, 19800, 3937, 0],
  ['yd', 'm', 0, 0.9144, 1, 0],
  ['yd[BnA]', 'm', 0, 0.9143992, 1, 0],
  ['yd[BnB]', 'm', 0, 36, 39.370113, 0],
  ['yd[Cla]', 'm', 0, 0.9143917962, 1, 0],
  ['yd[Ind]', 'm', 0, 36, 39.370142, 0],
  ['yd[Ind37]', 'm', 0, 0.91439523, 1, 0],
  ['yd[Ind62]', 'm', 0, 0.9143988, 1, 0],
  ['yd[Ind75]', 'm', 0, 0.9143985, 1, 0],
  ['yd[Se]', 'm', 0, 36, 39.370147, 0],
  ['yd[SeT]', 'm', 0, 0.914398, 1, 0],
  ['yd[US]', 'm', 0, 3600, 3937, 0],
  ['m3/m2'],
  ['0.1 ft', 'm', 0, 0.03048, 1, 0],
  ['0.1 ft[US]', 'm', 0, 1200, 39370, 0],
  ['0.1 in', 'm', 0, 0.00254, 1, 0],
  ['0.1 yd', 'm', 0, 0.09144, 1, 0],
  ['1/16 in', 'm', 0, 0.0254, 16, 0],
  ['1/2 ft', 'm', 0, 0.3048, 2, 0],
  ['1/32 in', 'm', 0, 0.0254, 32, 0],
  ['1/64 in', 'm', 0, 0.0254, 64, 0],
  ['10 ft', 'm', 0, 3.048, 1, 0],
  ['10 in', 'm', 0, 0.254, 1, 0],
  ['10 km', 'm', 0, 1e4, 1, 0],
  ['100 ft', 'm', 0, 30.48, 1, 0],
  ['100 km', 'm', 0, 1e5, 1, 0],
  ['1000 ft', 'm', 0, 304.8, 1, 0],
  ['30 ft', 'm', 0, 9.144, 1, 0],
  ['30 m', 'm', 0, 30, 1, 0],
  ['1E6 bbl/acre', 'm3/m2', 0, 2.464298142777857232e12, 6.27264e10, 0],
  ['bbl/acre', 'm3/m2', 0, 2.464298142777857232e6, 6.27264e10, 0],
  ['ft3/ft2', 'm3/m2', 0, 0.3048, 1, 0],
  ['cm', 'm', 0, 0.01, 1, 0],
  ['dam', 'm', 0, 10, 1, 0],
  ['dm', 'm', 0, 0.1, 1, 0],
  ['Em', 'm', 0, 1e18, 1, 0],
  ['fm', 'm', 0, 1e-15, 1, 0],
  ['Gm', 'm', 0, 1e9, 1, 0],
  ['hm', 'm', 0, 100, 1, 0],
  ['km', 'm', 0, 1e3, 1, 0],
  ['Mm', 'm', 0, 1e6, 1, 0],
  ['mm', 'm', 0, 1e-3, 1, 0],
  ['nm', 'm', 0, 1e-9, 1, 0],
  ['pm', 'm', 0, 1e-12, 1, 0],
  ['Tm', 'm', 0, 1e12, 1, 0],
  ['um', 'm', 0, 1e-6, 1, 0],
  ['m/deltaK'],
  ['ft/deltaF', 'm/deltaK', 0, 2.7432, 5, 0],
  ['m/kg'],
  ['ft/lbm', 'm/kg', 0, 0.3048, 0.45359237, 0],
  ['knot', 'm/s', 0, 1852, 3600, 0],
  ['m/s'],
  ['m3/(s.m2)'],
  ['1000 ft/h', 'm/s', 0, 304.8, 3600, 0],
  ['1000 ft/s', 'm/s', 0, 304.8, 1, 0],
  ['cm/a', 'm/s', 0, 0.01, 3.15576e7, 0],
  ['cm/s', 'm/s', 0, 0.01, 1, 0],
  ['dm/s', 'm/s', 0, 0.1, 1, 0],
  ['ft/d', 'm/s', 0, 0.3048, 86400, 0],
  ['ft/h', 'm/s', 0, 0.3048, 3600, 0],
  ['ft/min', 'm/s', 0, 0.3048, 60, 0],
  ['ft/ms', 'm/s', 0, 304.8, 1, 0],
  ['ft/s', 'm/s', 0, 0.3048, 1, 0],
  ['ft/us', 'm/s', 0, 304800, 1, 0],
  ['in/a', 'm/s', 0, 0.0254, 3.15576e7, 0],
  ['in/min', 'm/s', 0, 0.0254, 60, 0],
  ['in/s', 'm/s', 0, 0.0254, 1, 0],
  ['km/h', 'm/s', 0, 1, 3.6, 0],
  ['km/s', 'm/s', 0, 1e3, 1, 0],
  ['m/d', 'm/s', 0, 1, 86400, 0],
  ['m/h', 'm/s', 0, 1, 3600, 0],
  ['m/min', 'm/s', 0, 1, 60, 0],
  ['m/ms', 'm/s', 0, 1e3, 1, 0],
  ['mi/h', 'm/s', 0, 1609.344, 3600, 0],
  ['mil/a', 'm/s', 0, 2.54e-5, 3.15576e7, 0],
  ['mm/a', 'm/s', 0, 1e-3, 3.15576e7, 0],
  ['mm/s', 'm/s', 0, 1e-3, 1, 0],
  ['nm/s', 'm/s', 0, 1e-9, 1, 0],
  ['um/s', 'm/s', 0, 1e-6, 1, 0],
  ['ft3/(min.ft2)', 'm3/(s.m2)', 0, 0.3048, 60, 0],
  ['ft3/(s.ft2)', 'm3/(s.m2)', 0, 0.3048, 1, 0],
  ['gal[UK]/(h.ft2)', 'm3/(s.m2)', 0, 0.00454609, 334.450944, 0],
  ['gal[UK]/(h.in2)', 'm3/(s.m2)', 0, 0.00454609, 2.322576, 0],
  ['gal[UK]/(min.ft2)', 'm3/(s.m2)', 0, 0.00454609, 5.5741824, 0],
  ['gal[US]/(h.ft2)', 'm3/(s.m2)', 0, 0.003785411784, 334.450944, 0],
  ['gal[US]/(h.in2)', 'm3/(s.m2)', 0, 0.003785411784, 2.322576, 0],
  ['gal[US]/(min.ft2)', 'm3/(s.m2)', 0, 0.003785411784, 5.5741824, 0],
  ['Gal', 'm/s2', 0, 0.01, 1, 0],
  ['gn', 'm/s2', 0, 9.80665, 1, 0],
  ['m/s2'],
  ['cm/s2', 'm/s2', 0, 0.01, 1, 0],
  ['ft/s2', 'm/s2', 0, 0.3048, 1, 0],
  ['in/s2', 'm/s2', 0, 0.0254, 1, 0],
  ['mGal', 'm/s2', 0, 1e-5, 1, 0],
  ['mgn', 'm/s2', 0, 9.80665e-3, 1, 0],
  ['TD[AMath.PI]'],
  ['acre', 'm2', 0, 6.27264e10, 1.5499969e7, 0],
  ['b', 'm2', 0, 1e-28, 1, 0],
  ['ha', 'm2', 0, 1e4, 1, 0],
  ['section', 'm2', 0, 4.0144896e13, 1.5499969e7, 0],
  ['D', 'TD[AMath.PI]', 0, 1e-12, 1.01325, 0],
  ['D[AMath.PI]', 'TD[AMath.PI]', 0, 1e-12, 1, 0],
  ['m3/m'],
  ['cm2', 'm2', 0, 1e-4, 1, 0],
  ['km2', 'm2', 0, 1e6, 1, 0],
  ['mm2', 'm2', 0, 1e-6, 1, 0],
  ['um2', 'm2', 0, 1e-12, 1, 0],
  ['0.01 dm3/km', 'm3/m', 0, 1e-8, 1, 0],
  ['0.01 L/km', 'm3/m', 0, 1e-8, 1, 0],
  ['bbl/ft', 'm3/m', 0, 0.158987294928, 0.3048, 0],
  ['bbl/in', 'm3/m', 0, 0.158987294928, 0.0254, 0],
  ['bbl/mi', 'm3/m', 0, 0.158987294928, 1609.344, 0],
  ['dm3/m', 'm3/m', 0, 1e-3, 1, 0],
  ['ft3/ft', 'm3/m', 0, 0.09290304, 1, 0],
  ['gal[UK]/mi', 'm3/m', 0, 0.00454609, 1609.344, 0],
  ['gal[US]/ft', 'm3/m', 0, 0.003785411784, 0.3048, 0],
  ['gal[US]/mi', 'm3/m', 0, 0.003785411784, 1609.344, 0],
  ['in3/ft', 'm3/m', 0, 1.6387064e-5, 0.3048, 0],
  ['L/m', 'm3/m', 0, 1e-3, 1, 0],
  ['L/sec', 'm3/m', 0, 1e-3, 0.0166666666666667, 0],
  ['m3/km', 'm3/m', 0, 1e-3, 1, 0],
  ['m2'],
  ['ft2', 'm2', 0, 0.09290304, 1, 0],
  ['in2', 'm2', 0, 6.4516e-4, 1, 0],
  ['mi[US]2', 'm2', 0, 4.0144896e13, 1.5499969e7, 0],
  ['mi2', 'm2', 0, 2589988.110336, 1, 0],
  ['yd2', 'm2', 0, 0.83612736, 1, 0],
  ['mD', 'TD[AMath.PI]', 0, 1e-15, 1.01325, 0],
  ['J/(kg.deltaK)'],
  ['Btu[IT]/(lbm.deltaF)', 'J/(kg.deltaK)', 0, 4186.8, 1, 0],
  ['Btu[IT]/(lbm.deltaR)', 'J/(kg.deltaK)', 0, 4186.8, 1, 0],
  ['cal[th]/(g.deltaK)', 'J/(kg.deltaK)', 0, 4184, 1, 0],
  ['J/(g.deltaK)', 'J/(kg.deltaK)', 0, 1e3, 1, 0],
  ['kcal[th]/(kg.deltaC)', 'J/(kg.deltaK)', 0, 4184, 1, 0],
  ['kJ/(kg.deltaK)', 'J/(kg.deltaK)', 0, 1e3, 1, 0],
  ['kW.h/(kg.deltaC)', 'J/(kg.deltaK)', 0, 3.6e6, 1, 0],
  ['m2/kg'],
  ['cm2/g', 'm2/kg', 0, 0.1, 1, 0],
  ['ft2/lbm', 'm2/kg', 0, 0.09290304, 0.45359237, 0],
  ['m2/g', 'm2/kg', 0, 1e3, 1, 0],
  ['m2/mol'],
  ['St', 'm2/s', 0, 1e-4, 1, 0],
  ['m2/s'],
  ['m3/(s.m)'],
  ['mol.m2/(mol.s)'],
  ['Pa.s.m3/kg'],
  ['W.m2.deltaK/(J.deltaK)'],
  ['cm2/s', 'm2/s', 0, 1e-4, 1, 0],
  ['ft2/h', 'm2/s', 0, 0.09290304, 3600, 0],
  ['ft2/s', 'm2/s', 0, 0.09290304, 1, 0],
  ['in2/s', 'm2/s', 0, 6.4516e-4, 1, 0],
  ['m2/d', 'm2/s', 0, 1, 86400, 0],
  ['m2/h', 'm2/s', 0, 1, 3600, 0],
  ['mm2/s', 'm2/s', 0, 1e-6, 1, 0],
  ['1000 ft3/(d.ft)', 'm3/(s.m)', 0, 28.316846592, 2.633472e4, 0],
  ['1000 m3/(d.m)', 'm3/(s.m)', 0, 1e3, 86400, 0],
  ['1000 m3/(h.m)', 'm3/(s.m)', 0, 1e3, 3600, 0],
  ['bbl/(d.ft)', 'm3/(s.m)', 0, 0.158987294928, 2.633472e4, 0],
  ['ft3/(d.ft)', 'm3/(s.m)', 0, 0.09290304, 86400, 0],
  ['gal[UK]/(h.ft)', 'm3/(s.m)', 0, 0.00454609, 1.09728e3, 0],
  ['gal[UK]/(h.in)', 'm3/(s.m)', 0, 0.00454609, 91.44, 0],
  ['gal[UK]/(min.ft)', 'm3/(s.m)', 0, 0.00454609, 18.288, 0],
  ['gal[US]/(h.ft)', 'm3/(s.m)', 0, 0.003785411784, 1.09728e3, 0],
  ['gal[US]/(h.in)', 'm3/(s.m)', 0, 0.003785411784, 91.44, 0],
  ['gal[US]/(min.ft)', 'm3/(s.m)', 0, 0.003785411784, 18.288, 0],
  ['m3/(d.m)', 'm3/(s.m)', 0, 1, 86400, 0],
  ['m3/(h.m)', 'm3/(s.m)', 0, 1, 3600, 0],
  ['m3/(s.ft)', 'm3/(s.m)', 0, 1, 0.3048, 0],
  ['cSt', 'm2/s', 0, 1e-6, 1, 0],
  ['rd', 'Gy', 0, 0.01, 1, 0],
  ['Gy'],
  ['Sv'],
  ['rem', 'Sv', 0, 0.01, 1, 0],
  ['J/kg'],
  ['Btu[IT]/lbm', 'J/kg', 0, 2326, 1, 0],
  ['cal[th]/g', 'J/kg', 0, 4184, 1, 0],
  ['cal[th]/kg', 'J/kg', 0, 4.184, 1, 0],
  ['cal[th]/lbm', 'J/kg', 0, 4.184, 0.45359237, 0],
  ['erg/g', 'J/kg', 0, 1e-4, 1, 0],
  ['erg/kg', 'J/kg', 0, 1e-7, 1, 0],
  ['hp.h/lbm', 'J/kg', 0, 2.684519537696172792e6, 0.45359237, 0],
  ['J/g', 'J/kg', 0, 1e3, 1, 0],
  ['kcal[th]/g', 'J/kg', 0, 4.184e6, 1, 0],
  ['kcal[th]/kg', 'J/kg', 0, 4184, 1, 0],
  ['kJ/kg', 'J/kg', 0, 1e3, 1, 0],
  ['kW.h/kg', 'J/kg', 0, 3.6e6, 1, 0],
  ['lbf.ft/lbm', 'J/kg', 0, 1.3558179483314004, 0.45359237, 0],
  ['MJ/kg', 'J/kg', 0, 1e6, 1, 0],
  ['MW.h/kg', 'J/kg', 0, 3.6e9, 1, 0],
  ['cGy', 'Gy', 0, 0.01, 1, 0],
  ['crd', 'Gy', 0, 1e-4, 1, 0],
  ['dGy', 'Gy', 0, 0.1, 1, 0],
  ['drd', 'Gy', 0, 1e-3, 1, 0],
  ['EGy', 'Gy', 0, 1e18, 1, 0],
  ['Erd', 'Gy', 0, 1e16, 1, 0],
  ['fGy', 'Gy', 0, 1e-15, 1, 0],
  ['frd', 'Gy', 0, 1e-17, 1, 0],
  ['GGy', 'Gy', 0, 1e9, 1, 0],
  ['Grd', 'Gy', 0, 1e7, 1, 0],
  ['kGy', 'Gy', 0, 1e3, 1, 0],
  ['krd', 'Gy', 0, 10, 1, 0],
  ['mGy', 'Gy', 0, 1e-3, 1, 0],
  ['MGy', 'Gy', 0, 1e6, 1, 0],
  ['mrd', 'Gy', 0, 1e-5, 1, 0],
  ['Mrd', 'Gy', 0, 1e4, 1, 0],
  ['nGy', 'Gy', 0, 1e-9, 1, 0],
  ['nrd', 'Gy', 0, 1e-11, 1, 0],
  ['pGy', 'Gy', 0, 1e-12, 1, 0],
  ['prd', 'Gy', 0, 1e-14, 1, 0],
  ['TGy', 'Gy', 0, 1e12, 1, 0],
  ['Trd', 'Gy', 0, 1e10, 1, 0],
  ['uGy', 'Gy', 0, 1e-6, 1, 0],
  ['urd', 'Gy', 0, 1e-8, 1, 0],
  ['mrem', 'Sv', 0, 1e-5, 1, 0],
  ['mSv', 'Sv', 0, 1e-3, 1, 0],
  ['Sv/s'],
  ['mrem/h', 'Sv/s', 0, 1e-5, 3600, 0],
  ['mSv/h', 'Sv/s', 0, 1e-3, 3600, 0],
  ['rem/h', 'Sv/s', 0, 0.01, 3600, 0],
  ['Sv/h', 'Sv/s', 0, 1, 3600, 0],
  ['kg.m2'],
  ['lbm.ft2', 'kg.m2', 0, 4.21401100938048e-2, 1, 0],
  ['J/(mol.deltaK)'],
  ['Btu[IT]/(lbmol.deltaF)', 'J/(mol.deltaK)', 0, 4.1868, 1, 0],
  ['cal[th]/(mol.deltaC)', 'J/(mol.deltaK)', 0, 4.184, 1, 0],
  ['kJ/(kmol.deltaK)', 'J/(mol.deltaK)', 0, 1.0, 1, 0],
  ['J/deltaK'],
  ['W/deltaK'],
  ['H'],
  ['cH', 'H', 0, 0.01, 1, 0],
  ['dH', 'H', 0, 0.1, 1, 0],
  ['EH', 'H', 0, 1e18, 1, 0],
  ['fH', 'H', 0, 1e-15, 1, 0],
  ['GH', 'H', 0, 1e9, 1, 0],
  ['kH', 'H', 0, 1e3, 1, 0],
  ['mH', 'H', 0, 1e-3, 1, 0],
  ['MH', 'H', 0, 1e6, 1, 0],
  ['nH', 'H', 0, 1e-9, 1, 0],
  ['TH', 'H', 0, 1e12, 1, 0],
  ['uH', 'H', 0, 1e-6, 1, 0],
  ['ohm'],
  ['cohm', 'ohm', 0, 0.01, 1, 0],
  ['dohm', 'ohm', 0, 0.1, 1, 0],
  ['Eohm', 'ohm', 0, 1e18, 1, 0],
  ['fohm', 'ohm', 0, 1e-15, 1, 0],
  ['Gohm', 'ohm', 0, 1e9, 1, 0],
  ['kohm', 'ohm', 0, 1e3, 1, 0],
  ['mohm', 'ohm', 0, 1e-3, 1, 0],
  ['Mohm', 'ohm', 0, 1e6, 1, 0],
  ['nohm', 'ohm', 0, 1e-9, 1, 0],
  ['pohm', 'ohm', 0, 1e-12, 1, 0],
  ['Tohm', 'ohm', 0, 1e12, 1, 0],
  ['uohm', 'ohm', 0, 1e-6, 1, 0],
  ['Wb'],
  ['cWb', 'Wb', 0, 0.01, 1, 0],
  ['dWb', 'Wb', 0, 0.1, 1, 0],
  ['EWb', 'Wb', 0, 1e18, 1, 0],
  ['fWb', 'Wb', 0, 1e-15, 1, 0],
  ['GWb', 'Wb', 0, 1e9, 1, 0],
  ['kWb', 'Wb', 0, 1e3, 1, 0],
  ['mWb', 'Wb', 0, 1e-3, 1, 0],
  ['MWb', 'Wb', 0, 1e6, 1, 0],
  ['nWb', 'Wb', 0, 1e-9, 1, 0],
  ['pWb', 'Wb', 0, 1e-12, 1, 0],
  ['TWb', 'Wb', 0, 1e12, 1, 0],
  ['uWb', 'Wb', 0, 1e-6, 1, 0],
  ['V'],
  ['cV', 'V', 0, 0.01, 1, 0],
  ['dV', 'V', 0, 0.1, 1, 0],
  ['fV', 'V', 0, 1e-15, 1, 0],
  ['GV', 'V', 0, 1e9, 1, 0],
  ['kV', 'V', 0, 1e3, 1, 0],
  ['mV', 'V', 0, 1e-3, 1, 0],
  ['MV', 'V', 0, 1e6, 1, 0],
  ['nV', 'V', 0, 1e-9, 1, 0],
  ['pV', 'V', 0, 1e-12, 1, 0],
  ['TV', 'V', 0, 1e12, 1, 0],
  ['uV', 'V', 0, 1e-6, 1, 0],
  ['J/mol'],
  ['Btu[IT]/lbmol', 'J/mol', 0, 2.326, 1, 0],
  ['kcal[th]/mol', 'J/mol', 0, 4184, 1, 0],
  ['kJ/kmol', 'J/mol', 0, 1.0, 1, 0],
  ['MJ/kmol', 'J/mol', 0, 1e3, 1, 0],
  ['W/sr'],
  ['J'],
  ['Btu[IT]', 'J', 0, 1055.05585262, 1, 0],
  ['Btu[th]', 'J', 0, 9.4891523804e3, 9, 0],
  ['Btu[UK]', 'J', 0, 1055.05585257348, 1, 0],
  ['cal[IT]', 'J', 0, 4.1868, 1, 0],
  ['cal[th]', 'J', 0, 4.184, 1, 0],
  ['erg', 'J', 0, 1e-7, 1, 0],
  ['eV', 'J', 0, 1.602176487e-19, 1, 0],
  ['quad', 'J', 0, 1.05505585262e18, 1, 0],
  ['therm[EC]', 'J', 0, 1.05506e8, 1, 0],
  ['therm[UK]', 'J', 0, 1.05505585257348e8, 1, 0],
  ['therm[US]', 'J', 0, 1.054804e8, 1, 0],
  ['N.m'],
  ['1E6 Btu[IT]', 'J', 0, 1.05505585262e9, 1, 0],
  ['GW.h', 'J', 0, 3.6e12, 1, 0],
  ['hp.h', 'J', 0, 2.684519537696172792e6, 1, 0],
  ['hp[metric].h', 'J', 0, 2.6477955e6, 1, 0],
  ['kW.h', 'J', 0, 3.6e6, 1, 0],
  ['MW.h', 'J', 0, 3.6e9, 1, 0],
  ['TW.h', 'J', 0, 3.6e15, 1, 0],
  ['1000 lbf.ft', 'N.m', 0, 1.3558179483314004e3, 1, 0],
  ['daN.m', 'N.m', 0, 10, 1, 0],
  ['dN.m', 'N.m', 0, 0.1, 1, 0],
  ['kgf.m', 'N.m', 0, 9.80665, 1, 0],
  ['kN.m', 'N.m', 0, 1e3, 1, 0],
  ['lbf.ft', 'N.m', 0, 1.3558179483314004, 1, 0],
  ['lbf.in', 'N.m', 0, 0.1129848290276167, 1, 0],
  ['lbm.ft2/s2', 'N.m', 0, 0.0421401100938048, 1, 0],
  ['pdl.ft', 'N.m', 0, 0.0421401100938048, 1, 0],
  ['tonf[US].ft', 'N.m', 0, 2.7116358966628008e3, 1, 0],
  ['tonf[US].mi', 'N.m', 0, 1.4317437534379588224e7, 1, 0],
  ['aJ', 'J', 0, 1e-18, 1, 0],
  ['ccal[th]', 'J', 0, 0.04184, 1, 0],
  ['ceV', 'J', 0, 1.602176487e-21, 1, 0],
  ['cJ', 'J', 0, 0.01, 1, 0],
  ['dcal[th]', 'J', 0, 0.4184, 1, 0],
  ['deV', 'J', 0, 1.602176487e-20, 1, 0],
  ['dJ', 'J', 0, 0.1, 1, 0],
  ['Ecal[th]', 'J', 0, 4.184e18, 1, 0],
  ['EeV', 'J', 0, 1.602176487e-1, 1, 0],
  ['EJ', 'J', 0, 1e18, 1, 0],
  ['fcal[th]', 'J', 0, 4.184e-15, 1, 0],
  ['feV', 'J', 0, 1.602176487e-34, 1, 0],
  ['fJ', 'J', 0, 1e-15, 1, 0],
  ['Gcal[th]', 'J', 0, 4.184e9, 1, 0],
  ['GeV', 'J', 0, 1.602176487e-10, 1, 0],
  ['GJ', 'J', 0, 1e9, 1, 0],
  ['kcal[th]', 'J', 0, 4184, 1, 0],
  ['keV', 'J', 0, 1.602176487e-16, 1, 0],
  ['kJ', 'J', 0, 1e3, 1, 0],
  ['mcal[th]', 'J', 0, 0.004184, 1, 0],
  ['Mcal[th]', 'J', 0, 4.184e6, 1, 0],
  ['MeV', 'J', 0, 1.602176487e-13, 1, 0],
  ['meV', 'J', 0, 1.602176487e-22, 1, 0],
  ['mJ', 'J', 0, 1e-3, 1, 0],
  ['MJ', 'J', 0, 1e6, 1, 0],
  ['ncal[th]', 'J', 0, 4.184e-9, 1, 0],
  ['neV', 'J', 0, 1.602176487e-28, 1, 0],
  ['nJ', 'J', 0, 1e-9, 1, 0],
  ['pcal[th]', 'J', 0, 4.184e-12, 1, 0],
  ['peV', 'J', 0, 1.602176487e-31, 1, 0],
  ['pJ', 'J', 0, 1e-12, 1, 0],
  ['Tcal[th]', 'J', 0, 4.184e12, 1, 0],
  ['TeV', 'J', 0, 1.602176487e-7, 1, 0],
  ['TJ', 'J', 0, 1e12, 1, 0],
  ['ucal[th]', 'J', 0, 4.184e-6, 1, 0],
  ['ueV', 'J', 0, 1.602176487e-25, 1, 0],
  ['uJ', 'J', 0, 1e-6, 1, 0],
  ['W'],
  ['hp', 'W', 0, 745.69987158227022, 1, 0],
  ['hp[elec]', 'W', 0, 746, 1, 0],
  ['hp[hyd]', 'W', 0, 746.043, 1, 0],
  ['hp[metric]', 'W', 0, 735.49875, 1, 0],
  ['tonRefrig', 'W', 0, 1.266067023144e7, 3600, 0],
  ['J/s'],
  ['1E6 Btu[IT]/h', 'J/s', 0, 1.05505585262e9, 3600, 0],
  ['Btu[IT]/h', 'J/s', 0, 1055.05585262, 3600, 0],
  ['Btu[IT]/min', 'J/s', 0, 1055.05585262, 60, 0],
  ['Btu[IT]/s', 'J/s', 0, 1055.05585262, 1, 0],
  ['cal[th]/h', 'J/s', 0, 4.184, 3600, 0],
  ['EJ/a', 'J/s', 0, 1e18, 3.15576e7, 0],
  ['erg/a', 'J/s', 0, 1e-7, 3.15576e7, 0],
  ['kcal[th]/h', 'J/s', 0, 4184, 3600, 0],
  ['lbf.ft/min', 'J/s', 0, 1.3558179483314004, 60, 0],
  ['lbf.ft/s', 'J/s', 0, 1.3558179483314004, 1, 0],
  ['MJ/a', 'J/s', 0, 1e6, 3.15576e7, 0],
  ['quad/a', 'J/s', 0, 1.05505585262e18, 3.15576e7, 0],
  ['TJ/a', 'J/s', 0, 1e12, 3.15576e7, 0],
  ['ucal[th]/s', 'J/s', 0, 4.184e-6, 1, 0],
  ['cW', 'W', 0, 0.01, 1, 0],
  ['dW', 'W', 0, 0.1, 1, 0],
  ['EW', 'W', 0, 1e18, 1, 0],
  ['fW', 'W', 0, 1e-15, 1, 0],
  ['GW', 'W', 0, 1e9, 1, 0],
  ['kW', 'W', 0, 1e3, 1, 0],
  ['mW', 'W', 0, 1e-3, 1, 0],
  ['MW', 'W', 0, 1e6, 1, 0],
  ['nW', 'W', 0, 1e-9, 1, 0],
  ['pW', 'W', 0, 1e-12, 1, 0],
  ['TW', 'W', 0, 1e12, 1, 0],
  ['uW', 'W', 0, 1e-6, 1, 0],
  ['m/Pa'],
  ['ft/psi', 'm/Pa', 0, 1.96644768e-4, 4.4482216152605, 0],
  ['m/kPa', 'm/Pa', 0, 1e-3, 1, 0],
  ['bbl', 'm3', 0, 0.158987294928, 1, 0],
  ['floz[UK]', 'm3', 0, 0.00454609, 160, 0],
  ['floz[US]', 'm3', 0, 0.003785411784, 128, 0],
  ['gal[UK]', 'm3', 0, 0.00454609, 1, 0],
  ['gal[US]', 'm3', 0, 0.003785411784, 1, 0],
  ['L', 'm3', 0, 1e-3, 1, 0],
  ['pt[UK]', 'm3', 0, 0.00454609, 8, 0],
  ['pt[US]', 'm3', 0, 0.003785411784, 8, 0],
  ['qt[UK]', 'm3', 0, 0.00454609, 4, 0],
  ['qt[US]', 'm3', 0, 0.003785411784, 4, 0],
  ['TD[AMath.PI].m'],
  ['1000 bbl', 'm3', 0, 158.987294928, 1, 0],
  ['1000 ft3', 'm3', 0, 28.316846592, 1, 0],
  ['1000 gal[UK]', 'm3', 0, 4.54609, 1, 0],
  ['1000 gal[US]', 'm3', 0, 3.785411784, 1, 0],
  ['1000 m3', 'm3', 0, 1e3, 1, 0],
  ['1E12 ft3', 'm3', 0, 2.8316846592e10, 1, 0],
  ['1E6 bbl', 'm3', 0, 1.58987294928e5, 1, 0],
  ['1E6 ft3', 'm3', 0, 2.8316846592e4, 1, 0],
  ['1E-6 gal[US]', 'm3', 0, 3.785411784e-9, 1, 0],
  ['1E6 m3', 'm3', 0, 1e6, 1, 0],
  ['1E9 bbl', 'm3', 0, 1.58987294928e8, 1, 0],
  ['1E9 ft3', 'm3', 0, 2.8316846592e7, 1, 0],
  ['acre.ft', 'm3', 0, 1.911900672e10, 1.5499969e7, 0],
  ['cm3', 'm3', 0, 1e-6, 1, 0],
  ['dm3', 'm3', 0, 1e-3, 1, 0],
  ['ha.m', 'm3', 0, 1e4, 1, 0],
  ['km3', 'm3', 0, 1e9, 1, 0],
  ['mm3', 'm3', 0, 1e-9, 1, 0],
  ['um2.m', 'm3', 0, 1e-12, 1, 0],
  ['D.ft', 'TD[AMath.PI].m', 0, 0.3048e-12, 1.01325, 0],
  ['D.m', 'TD[AMath.PI].m', 0, 1e-12, 1.01325, 0],
  ['mD.ft', 'TD[AMath.PI].m', 0, 0.3048e-15, 1.01325, 0],
  ['mD.m', 'TD[AMath.PI].m', 0, 1e-15, 1.01325, 0],
  ['m3'],
  ['ft3', 'm3', 0, 0.028316846592, 1, 0],
  ['in3', 'm3', 0, 1.6387064e-5, 1, 0],
  ['mi3', 'm3', 0, 4.168181825440579584e9, 1, 0],
  ['yd3', 'm3', 0, 0.764554857984, 1, 0],
  ['hL', 'm3', 0, 0.1, 1, 0],
  ['mL', 'm3', 0, 1e-6, 1, 0],
  ['m3/rad'],
  ['ft3/rad', 'm3/rad', 0, 0.028316846592, 1, 0],
  ['m3/rev', 'm3/rad', 0, 1, 2 * Math.PI, 0],
  ['m3/kg'],
  ['0.01 L/kg', 'm3/kg', 0, 1e-5, 1, 0],
  ['bbl/ton[UK]', 'm3/kg', 0, 0.158987294928, 1016.0469088, 0],
  ['bbl/ton[US]', 'm3/kg', 0, 0.158987294928, 907.18474, 0],
  ['cm3/g', 'm3/kg', 0, 1e-3, 1, 0],
  ['dm3/kg', 'm3/kg', 0, 1e-3, 1, 0],
  ['dm3/t', 'm3/kg', 0, 1e-6, 1, 0],
  ['ft3/kg', 'm3/kg', 0, 0.028316846592, 1, 0],
  ['ft3/lbm', 'm3/kg', 0, 0.028316846592, 0.45359237, 0],
  ['ft3/sack[94lbm]', 'm3/kg', 0, 0.028316846592, 42.63768278, 0],
  ['gal[UK]/lbm', 'm3/kg', 0, 0.00454609, 0.45359237, 0],
  ['gal[US]/lbm', 'm3/kg', 0, 0.003785411784, 0.45359237, 0],
  ['gal[US]/sack[94lbm]', 'm3/kg', 0, 0.003785411784, 42.63768278, 0],
  ['gal[US]/ton[UK]', 'm3/kg', 0, 0.003785411784, 1016.0469088, 0],
  ['gal[US]/ton[US]', 'm3/kg', 0, 0.003785411784, 907.18474, 0],
  ['L/kg', 'm3/kg', 0, 1e-3, 1, 0],
  ['L/t', 'm3/kg', 0, 1e-6, 1, 0],
  ['L/ton[UK]', 'm3/kg', 0, 1e-3, 1016.0469088, 0],
  ['m3/g', 'm3/kg', 0, 1e3, 1, 0],
  ['m3/t', 'm3/kg', 0, 1e-3, 1, 0],
  ['m3/ton[UK]', 'm3/kg', 0, 1, 1016.0469088, 0],
  ['m3/ton[US]', 'm3/kg', 0, 1, 907.18474, 0],
  ['m3/mol'],
  ['dm3/kmol', 'm3/mol', 0, 1e-6, 1, 0],
  ['ft3/lbmol', 'm3/mol', 0, 0.028316846592, 453.59237, 0],
  ['L/kmol', 'm3/mol', 0, 1e-6, 1, 0],
  ['L/mol', 'm3/mol', 0, 1e-3, 1, 0],
  ['m3/kmol', 'm3/mol', 0, 1e-3, 1, 0],
  ['m3/s'],
  ['1/30 cm3/min', 'm3/s', 0, 1e-6, 1800, 0],
  ['1000 bbl/d', 'm3/s', 0, 158.987294928, 8.64e4, 0],
  ['1000 ft3/d', 'm3/s', 0, 28.316846592, 8.64e4, 0],
  ['1000 m3/d', 'm3/s', 0, 1e3, 8.64e4, 0],
  ['1000 m3/h', 'm3/s', 0, 1e3, 3600, 0],
  ['1E6 bbl/d', 'm3/s', 0, 1.58987294928e5, 86400, 0],
  ['1E6 ft3/d', 'm3/s', 0, 2.8316846592e4, 8.64e4, 0],
  ['1E6 m3/d', 'm3/s', 0, 1e6, 86400, 0],
  ['bbl/d', 'm3/s', 0, 0.158987294928, 8.64e4, 0],
  ['bbl/h', 'm3/s', 0, 0.158987294928, 3600, 0],
  ['bbl/min', 'm3/s', 0, 0.158987294928, 60, 0],
  ['cm3/h', 'm3/s', 0, 1e-6, 3600, 0],
  ['cm3/min', 'm3/s', 0, 1e-6, 60, 0],
  ['cm3/s', 'm3/s', 0, 1e-6, 1, 0],
  ['dm3/s', 'm3/s', 0, 1e-3, 1, 0],
  ['ft3/d', 'm3/s', 0, 0.028316846592, 8.64e4, 0],
  ['ft3/h', 'm3/s', 0, 0.028316846592, 3600, 0],
  ['ft3/min', 'm3/s', 0, 0.028316846592, 60, 0],
  ['ft3/s', 'm3/s', 0, 0.028316846592, 1, 0],
  ['gal[UK]/d', 'm3/s', 0, 4.54609e-3, 8.64e4, 0],
  ['gal[UK]/h', 'm3/s', 0, 4.54609e-3, 3600, 0],
  ['gal[UK]/min', 'm3/s', 0, 4.54609e-3, 60, 0],
  ['gal[US]/d', 'm3/s', 0, 3.785411784e-3, 86400, 0],
  ['gal[US]/h', 'm3/s', 0, 3.785411784e-3, 3600, 0],
  ['gal[US]/min', 'm3/s', 0, 3.785411784e-3, 60, 0],
  ['L/h', 'm3/s', 0, 1e-3, 3600, 0],
  ['L/min', 'm3/s', 0, 1e-3, 60, 0],
  ['L/s', 'm3/s', 0, 1e-3, 1, 0],
  ['m3/d', 'm3/s', 0, 1, 86400, 0],
  ['m3/h', 'm3/s', 0, 1, 3600, 0],
  ['m3/min', 'm3/s', 0, 1, 60, 0],
  ['m3/s2'],
  ['bbl/d2', 'm3/s2', 0, 0.158987294928, 7.46496e9, 0],
  ['bbl/h2', 'm3/s2', 0, 0.158987294928, 1.296e7, 0],
  ['dm3/s2', 'm3/s2', 0, 1e-3, 1, 0],
  ['ft3/d2', 'm3/s2', 0, 0.028316846592, 7.46496e9, 0],
  ['ft3/h2', 'm3/s2', 0, 0.028316846592, 1.296e7, 0],
  ['ft3/min2', 'm3/s2', 0, 0.028316846592, 3600, 0],
  ['ft3/s2', 'm3/s2', 0, 0.028316846592, 1, 0],
  ['gal[UK]/h2', 'm3/s2', 0, 4.54609e-3, 1.296e7, 0],
  ['gal[UK]/min2', 'm3/s2', 0, 4.54609e-3, 3600, 0],
  ['gal[US]/h2', 'm3/s2', 0, 3.785411784e-3, 1.296e7, 0],
  ['gal[US]/min2', 'm3/s2', 0, 3.785411784e-3, 3600, 0],
  ['L/s2', 'm3/s2', 0, 1e-3, 1, 0],
  ['m3/d2', 'm3/s2', 0, 1, 7.46496e9, 0],
  ['ohm.m'],
  ['kohm.m', 'ohm.m', 0, 1e3, 1, 0],
  ['nohm.mil2/ft', 'ohm.m', 0, 6.4516e-19, 0.3048, 0],
  ['nohm.mm2/m', 'ohm.m', 0, 1e-15, 1, 0],
  ['ohm.cm', 'ohm.m', 0, 0.01, 1, 0],
  ['ohm.m2/m', 'ohm.m', 0, 1, 1, 0],
  ['Wb.m'],
  ['N.m2'],
  ['dyne.cm2', 'N.m2', 0, 1e-9, 1, 0],
  ['kgf.m2', 'N.m2', 0, 9.80665, 1, 0],
  ['kN.m2', 'N.m2', 0, 1e3, 1, 0],
  ['lbf.in2', 'N.m2', 0, 2.86981465730146418e-3, 1, 0],
  ['mN.m2', 'N.m2', 0, 1e-3, 1, 0],
  ['pdl.cm2', 'N.m2', 0, 1.38254954376e-5, 1, 0],
  ['tonf[UK].ft2', 'N.m2', 0, 925.6874158591602859008, 1, 0],
  ['tonf[US].ft2', 'N.m2', 0, 826.50662130282168384, 1, 0],
  ['m2/(Pa.s)'],
  ['TD[AMath.PI]/(Pa.s)'],
  ['bbl/(ft.psi.d)', 'm2/(Pa.s)', 0, 1.0257224319574848e-4, 1.1714267073583299456e5, 0],
  ['ft3/(ft.psi.d)', 'm2/(Pa.s)', 0, 5.99373252864e-5, 3.843263475585072e5, 0],
  ['m2/(kPa.d)', 'm2/(Pa.s)', 0, 1, 8.64e7, 0],
  ['D/(Pa.s)', 'TD[AMath.PI]/(Pa.s)', 0, 1e-12, 1.01325, 0],
  ['D/cP', 'TD[AMath.PI]/(Pa.s)', 0, 1e-9, 1.01325, 0],
  ['mD.ft2/(lbf.s)', 'TD[AMath.PI]/(Pa.s)', 0, 9.290304e-17, 4.507160551662701625, 0],
  ['mD.in2/(lbf.s)', 'TD[AMath.PI]/(Pa.s)', 0, 6.4516e-19, 4.507160551662701625, 0],
  ['mD/(Pa.s)', 'TD[AMath.PI]/(Pa.s)', 0, 1e-15, 1.01325, 0],
  ['mD/cP', 'TD[AMath.PI]/(Pa.s)', 0, 1e-12, 1.01325, 0],
  ['cm4', 'm4', 0, 1e-8, 1, 0],
  ['m4'],
  ['in4', 'm4', 0, 4.162314256e-7, 1, 0],
  ['m4/s'],
  ['1000 bbl.ft/d', 'm4/s', 0, 48.4593274940544, 8.64e4, 0],
  ['1000 m4/d', 'm4/s', 0, 1e3, 86400, 0],
  ['m3/(Pa.s)'],
  ['1000 ft3/(psi.d)', 'm3/(Pa.s)', 0, 0.01826889674729472, 3.843263475585072e5, 0],
  ['bbl/(kPa.d)', 'm3/(Pa.s)', 0, 0.158987294928, 8.64e7, 0],
  ['bbl/(psi.d)', 'm3/(Pa.s)', 0, 1.0257224319574848e-4, 3.843263475585072e5, 0],
  ['L/(bar.min)', 'm3/(Pa.s)', 0, 1e-3, 6e6, 0],
  ['m3/(bar.d)', 'm3/(Pa.s)', 0, 1, 8.64e9, 0],
  ['m3/(bar.h)', 'm3/(Pa.s)', 0, 1, 3.6e8, 0],
  ['m3/(bar.min)', 'm3/(Pa.s)', 0, 1, 6e6, 0],
  ['m3/(kPa.d)', 'm3/(Pa.s)', 0, 1, 8.64e7, 0],
  ['m3/(kPa.h)', 'm3/(Pa.s)', 0, 1, 3.6e6, 0],
  ['m3/(psi.d)', 'm3/(Pa.s)', 0, 0.00064516, 3.843263475585072e5, 0],
  ['m3/Pa'],
  ['bbl/psi', 'm3/Pa', 0, 1.0257224319574848e-4, 4.4482216152605, 0],
  ['m3/kPa', 'm3/Pa', 0, 1e-3, 1, 0],
  ['kg.m'],
  ['lbm.ft', 'kg.m', 0, 0.138254954376, 1, 0],
  ['J.m/(s.m2.deltaK)'],
  ['W/(m.deltaK)'],
  ['Btu[IT].in/(h.ft2.deltaF)', 'J.m/(s.m2.deltaK)', 0, 241.185767908932, 1.67225472e3, 0],
  ['kJ.m/(h.m2.deltaK)', 'J.m/(s.m2.deltaK)', 0, 1, 3.6, 0],
  ['Btu[IT]/(h.ft.deltaF)', 'W/(m.deltaK)', 0, 9.49550267358e3, 5.4864e3, 0],
  ['cal[th]/(h.cm.deltaC)', 'W/(m.deltaK)', 0, 4.184, 36, 0],
  ['cal[th]/(s.cm.deltaC)', 'W/(m.deltaK)', 0, 418.4, 1, 0],
  ['kcal[th]/(h.m.deltaC)', 'W/(m.deltaK)', 0, 4.184e3, 3600, 0],
  ['uH/m', 'H/m', 0, 1e-6, 1, 0],
  ['H/m'],
  ['ohm/m'],
  ['uohm/ft', 'ohm/m', 0, 1e-6, 0.3048, 0],
  ['uohm/m', 'ohm/m', 0, 1e-6, 1, 0],
  ['Wb/m'],
  ['Wb/mm', 'Wb/m', 0, 1e3, 1, 0],
  ['V/m'],
  ['mV/ft', 'V/m', 0, 1e-3, 0.3048, 0],
  ['mV/m', 'V/m', 0, 1e-3, 1, 0],
  ['uV/ft', 'V/m', 0, 1e-6, 0.3048, 0],
  ['uV/m', 'V/m', 0, 1e-6, 1, 0],
  ['kg.m/s'],
  ['lbm.ft/s', 'kg.m/s', 0, 0.138254954376, 1, 0],
  ['N'],
  ['dyne', 'N', 0, 1e-5, 1, 0],
  ['gf', 'N', 0, 9.80665e-3, 1, 0],
  ['lbf', 'N', 0, 4.4482216152605, 1, 0],
  ['ozf', 'N', 0, 4.4482216152605, 16, 0],
  ['pdl', 'N', 0, 0.138254954376, 1, 0],
  ['tonf[UK]', 'N', 0, 9964.01641818352, 1, 0],
  ['tonf[US]', 'N', 0, 8896.443230521, 1, 0],
  ['J.m/m2'],
  ['J/m'],
  ['N.m/m'],
  ['kcal[th].m/cm2', 'J.m/m2', 0, 4.184e7, 1, 0],
  ['MJ/m', 'J/m', 0, 1e6, 1, 0],
  ['10 kN', 'N', 0, 1e4, 1, 0],
  ['kgf.m/m', 'N.m/m', 0, 9.80665, 1, 0],
  ['lbf.ft/in', 'N.m/m', 0, 53.378659383126, 1, 0],
  ['lbf.in/in', 'N.m/m', 0, 4.4482216152605, 1, 0],
  ['tonf[US].mi/ft', 'N.m/m', 0, 4.697322025715088e7, 1, 0],
  ['cN', 'N', 0, 0.01, 1, 0],
  ['daN', 'N', 0, 10, 1, 0],
  ['dN', 'N', 0, 0.1, 1, 0],
  ['EN', 'N', 0, 1e18, 1, 0],
  ['fN', 'N', 0, 1e-15, 1, 0],
  ['GN', 'N', 0, 1e9, 1, 0],
  ['hN', 'N', 0, 100, 1, 0],
  ['kdyne', 'N', 0, 0.01, 1, 0],
  ['kgf', 'N', 0, 9.80665, 1, 0],
  ['klbf', 'N', 0, 4.4482216152605e3, 1, 0],
  ['kN', 'N', 0, 1e3, 1, 0],
  ['Mgf', 'N', 0, 9.80665e3, 1, 0],
  ['mN', 'N', 0, 1e-3, 1, 0],
  ['MN', 'N', 0, 1e6, 1, 0],
  ['nN', 'N', 0, 1e-9, 1, 0],
  ['pN', 'N', 0, 1e-12, 1, 0],
  ['TN', 'N', 0, 1e12, 1, 0],
  ['uN', 'N', 0, 1e-6, 1, 0],
  ['1/bar', '1/Pa', 0, 1e-5, 1, 0],
  ['1/kPa', '1/Pa', 0, 1e-3, 1, 0],
  ['1/pPa', '1/Pa', 0, 1e12, 1, 0],
  ['1/psi', '1/Pa', 0, 0.00064516, 4.4482216152605, 0],
  ['1/upsi', '1/Pa', 0, 645.16, 4.4482216152605, 0],
  ['1/Pa'],
  ['m3/J'],
  ['dm3/(kW.h)', 'm3/J', 0, 1e-3, 3.6e6, 0],
  ['dm3/MJ', 'm3/J', 0, 1e-9, 1, 0],
  ['m3/(kW.h)', 'm3/J', 0, 1, 3.6e6, 0],
  ['mm3/J', 'm3/J', 0, 1e-9, 1, 0],
  ['pt[UK]/(hp.h)', 'm3/J', 0, 5.6826125e-4, 2.684519537696172792e6, 0],
  ['ct', 'kg', 0, 2e-4, 1, 0],
  ['cwt[UK]', 'kg', 0, 50.80234544, 1, 0],
  ['cwt[US]', 'kg', 0, 45.359237, 1, 0],
  ['g', 'kg', 0, 1e-3, 1, 0],
  ['grain', 'kg', 0, 6.479891e-5, 1, 0],
  ['lbm', 'kg', 0, 0.45359237, 1, 0],
  ['ozm', 'kg', 0, 0.45359237, 16, 0],
  ['ozm[troy]', 'kg', 0, 0.0311034768, 1, 0],
  ['sack[94lbm]', 'kg', 0, 42.63768278, 1, 0],
  ['t', 'kg', 0, 1e3, 1, 0],
  ['ton[UK]', 'kg', 0, 1016.0469088, 1, 0],
  ['ton[US]', 'kg', 0, 907.18474, 1, 0],
  ['kg'],
  ['ag', 'kg', 0, 1e-21, 1, 0],
  ['cg', 'kg', 0, 1e-5, 1, 0],
  ['Eg', 'kg', 0, 1e15, 1, 0],
  ['fg', 'kg', 0, 1e-18, 1, 0],
  ['Gg', 'kg', 0, 1e6, 1, 0],
  ['hg', 'kg', 0, 0.1, 1, 0],
  ['klbm', 'kg', 0, 453.59237, 1, 0],
  ['mg', 'kg', 0, 1e-6, 1, 0],
  ['Mg', 'kg', 0, 1e3, 1, 0],
  ['ng', 'kg', 0, 1e-12, 1, 0],
  ['pg', 'kg', 0, 1e-15, 1, 0],
  ['Tg', 'kg', 0, 1e9, 1, 0],
  ['ug', 'kg', 0, 1e-9, 1, 0],
  ['W/(m3.deltaK)'],
  ['Btu[IT]/(h.ft3.deltaF)', 'W/(m3.deltaK)', 0, 9.49550267358e3, 509.703238656, 0],
  ['Btu[IT]/(s.ft3.deltaF)', 'W/(m3.deltaK)', 0, 9.49550267358e3, 0.14158423296, 0],
  ['kW/(m3.deltaK)', 'W/(m3.deltaK)', 0, 1e3, 1, 0],
  ['W/(m2.deltaK)'],
  ['Btu[IT]/(h.ft2.deltaF)', 'W/(m2.deltaK)', 0, 9.49550267358e3, 1.67225472e3, 0],
  ['Btu[IT]/(h.ft2.deltaR)', 'W/(m2.deltaK)', 0, 9.49550267358e3, 1.67225472e3, 0],
  ['Btu[IT]/(h.m2.deltaC)', 'W/(m2.deltaK)', 0, 1055.05585262, 3600, 0],
  ['Btu[IT]/(s.ft2.deltaF)', 'W/(m2.deltaK)', 0, 9.49550267358e3, 0.4645152, 0],
  ['cal[th]/(h.cm2.deltaC)', 'W/(m2.deltaK)', 0, 4.184e4, 3600, 0],
  ['cal[th]/(s.cm2.deltaC)', 'W/(m2.deltaK)', 0, 41840, 1, 0],
  ['J/(s.m2.deltaC)', 'W/(m2.deltaK)', 0, 1, 1, 0],
  ['kcal[th]/(h.m2.deltaC)', 'W/(m2.deltaK)', 0, 4.184e3, 3600, 0],
  ['kJ/(h.m2.deltaK)', 'W/(m2.deltaK)', 0, 1e3, 3600, 0],
  ['kW/(m2.deltaK)', 'W/(m2.deltaK)', 0, 1e3, 1, 0],
  ['T/m'],
  ['gauss/cm', 'T/m', 0, 0.01, 1, 0],
  ['mT/dm', 'T/m', 0, 0.01, 1, 0],
  ['T'],
  ['gauss', 'T', 0, 1e-4, 1, 0],
  ['cgauss', 'T', 0, 1e-6, 1, 0],
  ['cT', 'T', 0, 0.01, 1, 0],
  ['dgauss', 'T', 0, 1e-5, 1, 0],
  ['dT', 'T', 0, 0.1, 1, 0],
  ['Egauss', 'T', 0, 1e14, 1, 0],
  ['ET', 'T', 0, 1e18, 1, 0],
  ['fgauss', 'T', 0, 1e-19, 1, 0],
  ['fT', 'T', 0, 1e-15, 1, 0],
  ['Ggauss', 'T', 0, 1e5, 1, 0],
  ['GT', 'T', 0, 1e9, 1, 0],
  ['kgauss', 'T', 0, 0.1, 1, 0],
  ['kT', 'T', 0, 1e3, 1, 0],
  ['mgauss', 'T', 0, 1e-7, 1, 0],
  ['Mgauss', 'T', 0, 100, 1, 0],
  ['mT', 'T', 0, 1e-3, 1, 0],
  ['ngauss', 'T', 0, 1e-13, 1, 0],
  ['nT', 'T', 0, 1e-9, 1, 0],
  ['pgauss', 'T', 0, 1e-16, 1, 0],
  ['pT', 'T', 0, 1e-12, 1, 0],
  ['Tgauss', 'T', 0, 1e8, 1, 0],
  ['TT', 'T', 0, 1e12, 1, 0],
  ['ugauss', 'T', 0, 1e-10, 1, 0],
  ['uT', 'T', 0, 1e-6, 1, 0],
  ['kg/m'],
  ['kg.m/cm2', 'kg/m', 0, 1e4, 1, 0],
  ['klbm/in', 'kg/m', 0, 453.59237, 0.0254, 0],
  ['lbm/ft', 'kg/m', 0, 0.45359237, 0.3048, 0],
  ['Mg/in', 'kg/m', 0, 1e3, 0.0254, 0],
  ['kg/m2'],
  ['0.01 lbm/ft2', 'kg/m2', 0, 0.45359237, 9.290304, 0],
  ['lbm/ft2', 'kg/m2', 0, 0.45359237, 0.09290304, 0],
  ['Mg/m2', 'kg/m2', 0, 1e3, 1, 0],
  ['ton[US]/ft2', 'kg/m2', 0, 907.18474, 0.09290304, 0],
  ['kg/(m2.s)'],
  ['g.ft/(cm3.s)', 'kg/(m2.s)', 0, 304.8, 1, 0],
  ['g.m/(cm3.s)', 'kg/(m2.s)', 0, 1e3, 1, 0],
  ['kPa.s/m', 'kg/(m2.s)', 0, 1e3, 1, 0],
  ['lbm/(ft2.h)', 'kg/(m2.s)', 0, 0.45359237, 3.34450944e2, 0],
  ['lbm/(ft2.s)', 'kg/(m2.s)', 0, 0.45359237, 0.09290304, 0],
  ['MPa.s/m', 'kg/(m2.s)', 0, 1e6, 1, 0],
  ['N/m3'],
  ['0.001 psi/ft', 'N/m3', 0, 4.4482216152605, 0.196644768, 0],
  ['0.01 psi/ft', 'N/m3', 0, 4.4482216152605, 0.0196644768, 0],
  ['atm/ft', 'N/m3', 0, 1.01325e5, 0.3048, 0],
  ['atm/hm', 'N/m3', 0, 1.01325e3, 1, 0],
  ['atm/m', 'N/m3', 0, 1.01325e5, 1, 0],
  ['bar/km', 'N/m3', 0, 100, 1, 0],
  ['bar/m', 'N/m3', 0, 1e5, 1, 0],
  ['GPa/cm', 'N/m3', 0, 1e11, 1, 0],
  ['kPa/hm', 'N/m3', 0, 10, 1, 0],
  ['kPa/m', 'N/m3', 0, 1e3, 1, 0],
  ['lbf/ft3', 'N/m3', 0, 4.4482216152605, 0.028316846592, 0],
  ['lbf/gal[US]', 'N/m3', 0, 4.4482216152605, 3.785411784e-3, 0],
  ['MPa/m', 'N/m3', 0, 1e6, 1, 0],
  ['Pa/m', 'N/m3', 0, 1, 1, 0],
  ['psi/ft', 'N/m3', 0, 4.4482216152605, 1.96644768e-4, 0],
  ['psi/m', 'N/m3', 0, 4.4482216152605, 0.00064516, 0],
  ['kg/m3'],
  ['0.001 lbm/bbl', 'kg/m3', 0, 0.45359237, 158.987294928, 0],
  ['0.001 lbm/gal[UK]', 'kg/m3', 0, 0.45359237, 4.54609, 0],
  ['0.001 lbm/gal[US]', 'kg/m3', 0, 0.45359237, 3.785411784, 0],
  ['0.01 grain/ft3', 'kg/m3', 0, 6.479891e-5, 2.8316846592, 0],
  ['0.1 lbm/bbl', 'kg/m3', 0, 0.45359237, 1.58987294928, 0],
  ['10 Mg/m3', 'kg/m3', 0, 1e4, 1, 0],
  ['g/cm3', 'kg/m3', 0, 1e3, 1, 0],
  ['g/dm3', 'kg/m3', 0, 1, 1, 0],
  ['g/gal[UK]', 'kg/m3', 0, 1e-3, 4.54609e-3, 0],
  ['g/gal[US]', 'kg/m3', 0, 1e-3, 3.785411784e-3, 0],
  ['g/L', 'kg/m3', 0, 1, 1, 0],
  ['g/m3', 'kg/m3', 0, 1e-3, 1, 0],
  ['grain/ft3', 'kg/m3', 0, 6.479891e-5, 0.028316846592, 0],
  ['grain/gal[US]', 'kg/m3', 0, 6.479891e-5, 3.785411784e-3, 0],
  ['kg/dm3', 'kg/m3', 0, 1e3, 1, 0],
  ['kg/L', 'kg/m3', 0, 1e3, 1, 0],
  ['lbm/bbl', 'kg/m3', 0, 0.45359237, 0.158987294928, 0],
  ['lbm/ft3', 'kg/m3', 0, 0.45359237, 0.028316846592, 0],
  ['lbm/gal[UK]', 'kg/m3', 0, 0.45359237, 4.54609e-3, 0],
  ['lbm/gal[US]', 'kg/m3', 0, 0.45359237, 3.785411784e-3, 0],
  ['lbm/in3', 'kg/m3', 0, 0.45359237, 1.6387064e-5, 0],
  ['mg/dm3', 'kg/m3', 0, 1e-3, 1, 0],
  ['mg/gal[US]', 'kg/m3', 0, 1e-6, 3.785411784e-3, 0],
  ['mg/L', 'kg/m3', 0, 1e-3, 1, 0],
  ['Mg/m3', 'kg/m3', 0, 1e3, 1, 0],
  ['mg/m3', 'kg/m3', 0, 1e-6, 1, 0],
  ['t/m3', 'kg/m3', 0, 1e3, 1, 0],
  ['ug/cm3', 'kg/m3', 0, 1e-3, 1, 0],
  ['kg/m4'],
  ['g/cm4', 'kg/m4', 0, 1e5, 1, 0],
  ['kg/dm4', 'kg/m4', 0, 1e4, 1, 0],
  ['lbm/(gal[UK].ft)', 'kg/m4', 0, 0.45359237, 1.385648232e-3, 0],
  ['lbm/(gal[US].ft)', 'kg/m4', 0, 0.45359237, 1.1537935117632e-3, 0],
  ['lbm/ft4', 'kg/m4', 0, 0.45359237, 8.6309748412416e-3, 0],
  ['Pa.s2/m3', 'kg/m4', 0, 1, 1, 0],
  ['Pa.s/m3'],
  ['psi.d/bbl', 'Pa.s/m3', 0, 3.843263475585072e5, 1.0257224319574848e-4, 0],
  ['Pa/m3'],
  ['psi2.d/(cP.ft3)', 'Pa/m3', 0, 1.7095687665238712177121191256e9, 1.17863614254846615552e-8, 0],
  ['P', 'Pa.s', 0, 0.1, 1, 0],
  ['kg/(m.s)'],
  ['Pa.s'],
  ['lbm/(ft.h)', 'kg/(m.s)', 0, 0.45359237, 1.09728e3, 0],
  ['lbm/(ft.s)', 'kg/(m.s)', 0, 0.45359237, 0.3048, 0],
  ['dyne.s/cm2', 'Pa.s', 0, 0.1, 1, 0],
  ['kgf.s/m2', 'Pa.s', 0, 9.80665, 1, 0],
  ['lbf.s/ft2', 'Pa.s', 0, 4.4482216152605, 0.09290304, 0],
  ['lbf.s/in2', 'Pa.s', 0, 4.4482216152605, 6.4516e-4, 0],
  ['mPa.s', 'Pa.s', 0, 1e-3, 1, 0],
  ['N.s/m2', 'Pa.s', 0, 1, 1, 0],
  ['psi.s', 'Pa.s', 0, 4.4482216152605, 0.00064516, 0],
  ['cP', 'Pa.s', 0, 1e-3, 1, 0],
  ['dP', 'Pa.s', 0, 0.01, 1, 0],
  ['EP', 'Pa.s', 0, 1e17, 1, 0],
  ['fP', 'Pa.s', 0, 1e-16, 1, 0],
  ['GP', 'Pa.s', 0, 1e8, 1, 0],
  ['kP', 'Pa.s', 0, 100, 1, 0],
  ['mP', 'Pa.s', 0, 1e-4, 1, 0],
  ['MP', 'Pa.s', 0, 1e5, 1, 0],
  ['nP', 'Pa.s', 0, 1e-10, 1, 0],
  ['pP', 'Pa.s', 0, 1e-13, 1, 0],
  ['TP', 'Pa.s', 0, 1e11, 1, 0],
  ['uP', 'Pa.s', 0, 1e-7, 1, 0],
  ['Pa'],
  ['at', 'Pa', 0, 9.80665e4, 1, 0],
  ['atm', 'Pa', 0, 1.01325e5, 1, 0],
  ['bar', 'Pa', 0, 1e5, 1, 0],
  ['cmH2O[4degC]', 'Pa', 0, 98.0638, 1, 0],
  ['inH2O[39degF]', 'Pa', 0, 249.082, 1, 0],
  ['inH2O[60degF]', 'Pa', 0, 248.84, 1, 0],
  ['inHg[32degF]', 'Pa', 0, 3.38638e3, 1, 0],
  ['inHg[60degF]', 'Pa', 0, 3.37685e3, 1, 0],
  ['mmHg[0degC]', 'Pa', 0, 133.322, 1, 0],
  ['psi', 'Pa', 0, 4.4482216152605, 6.4516e-4, 0],
  ['torr', 'Pa', 0, 1.01325e5, 760, 0],
  ['umHg[0degC]', 'Pa', 0, 0.133322, 1, 0],
  ['J/m3'],
  ['Btu[IT]/bbl', 'J/m3', 0, 1055.05585262, 0.158987294928, 0],
  ['Btu[IT]/ft3', 'J/m3', 0, 1055.05585262, 0.028316846592, 0],
  ['Btu[IT]/gal[UK]', 'J/m3', 0, 1055.05585262, 4.54609e-3, 0],
  ['Btu[IT]/gal[US]', 'J/m3', 0, 1055.05585262, 3.785411784e-3, 0],
  ['cal[th]/cm3', 'J/m3', 0, 4.184e6, 1, 0],
  ['cal[th]/mL', 'J/m3', 0, 4.184e6, 1, 0],
  ['cal[th]/mm3', 'J/m3', 0, 4.184e9, 1, 0],
  ['erg/cm3', 'J/m3', 0, 0.1, 1, 0],
  ['erg/m3', 'J/m3', 0, 1e-7, 1, 0],
  ['hp.h/bbl', 'J/m3', 0, 2.684519537696172792e6, 0.158987294928, 0],
  ['J/dm3', 'J/m3', 0, 1e3, 1, 0],
  ['kcal[th]/cm3', 'J/m3', 0, 4.184e9, 1, 0],
  ['kcal[th]/m3', 'J/m3', 0, 4.184e3, 1, 0],
  ['kJ/dm3', 'J/m3', 0, 1e6, 1, 0],
  ['kJ/m3', 'J/m3', 0, 1e3, 1, 0],
  ['kW.h/dm3', 'J/m3', 0, 3.6e9, 1, 0],
  ['kW.h/m3', 'J/m3', 0, 3.6e6, 1, 0],
  ['lbf.ft/bbl', 'J/m3', 0, 1.3558179483314004, 0.158987294928, 0],
  ['lbf.ft/gal[US]', 'J/m3', 0, 1.3558179483314004, 3.785411784e-3, 0],
  ['MJ/m3', 'J/m3', 0, 1e6, 1, 0],
  ['MW.h/m3', 'J/m3', 0, 3.6e9, 1, 0],
  ['tonf[US].mi/bbl', 'J/m3', 0, 1.4317437534379588224e7, 0.158987294928, 0],
  ['0.01 lbf/ft2', 'Pa', 0, 4.4482216152605, 9.290304, 0],
  ['dyne/cm2', 'Pa', 0, 0.1, 1, 0],
  ['kgf/cm2', 'Pa', 0, 9.80665e4, 1, 0],
  ['kgf/m2', 'Pa', 0, 9.80665, 1, 0],
  ['kgf/mm2', 'Pa', 0, 9.80665e6, 1, 0],
  ['kN/m2', 'Pa', 0, 1e3, 1, 0],
  ['lbf/ft2', 'Pa', 0, 4.4482216152605, 0.09290304, 0],
  ['N/m2', 'Pa', 0, 1, 1, 0],
  ['N/mm2', 'Pa', 0, 1e6, 1, 0],
  ['tonf[UK]/ft2', 'Pa', 0, 9964.01641818352, 0.09290304, 0],
  ['tonf[US]/ft2', 'Pa', 0, 8896.443230521, 0.09290304, 0],
  ['tonf[US]/in2', 'Pa', 0, 8896.443230521, 6.4516e-4, 0],
  ['cPa', 'Pa', 0, 0.01, 1, 0],
  ['dPa', 'Pa', 0, 0.1, 1, 0],
  ['EPa', 'Pa', 0, 1e18, 1, 0],
  ['fPa', 'Pa', 0, 1e-15, 1, 0],
  ['GPa', 'Pa', 0, 1e9, 1, 0],
  ['hbar', 'Pa', 0, 1e7, 1, 0],
  ['kPa', 'Pa', 0, 1e3, 1, 0],
  ['kpsi', 'Pa', 0, 4.4482216152605e3, 6.4516e-4, 0],
  ['mbar', 'Pa', 0, 100, 1, 0],
  ['mPa', 'Pa', 0, 1e-3, 1, 0],
  ['MPa', 'Pa', 0, 1e6, 1, 0],
  ['Mpsi', 'Pa', 0, 4.4482216152605e6, 6.4516e-4, 0],
  ['nPa', 'Pa', 0, 1e-9, 1, 0],
  ['pPa', 'Pa', 0, 1e-12, 1, 0],
  ['TPa', 'Pa', 0, 1e12, 1, 0],
  ['ubar', 'Pa', 0, 0.1, 1, 0],
  ['uPa', 'Pa', 0, 1e-6, 1, 0],
  ['upsi', 'Pa', 0, 4.4482216152605e-6, 6.4516e-4, 0],
  ['Pa/s'],
  ['Pa2/(Pa.s)'],
  ['W/m3'],
  ['atm/h', 'Pa/s', 0, 1.01325e5, 3600, 0],
  ['bar/h', 'Pa/s', 0, 1e5, 3600, 0],
  ['kPa/h', 'Pa/s', 0, 1e3, 3600, 0],
  ['kPa/min', 'Pa/s', 0, 1e3, 60, 0],
  ['MPa/h', 'Pa/s', 0, 1e6, 3600, 0],
  ['Pa/h', 'Pa/s', 0, 1, 3600, 0],
  ['psi/h', 'Pa/s', 0, 4.4482216152605, 2.322576, 0],
  ['psi/min', 'Pa/s', 0, 4.4482216152605, 0.0387096, 0],
  ['0.001 kPa2/cP', 'Pa2/(Pa.s)', 0, 1e6, 1, 0],
  ['bar2/cP', 'Pa2/(Pa.s)', 0, 1e13, 1, 0],
  ['kPa2/cP', 'Pa2/(Pa.s)', 0, 1e9, 1, 0],
  ['psi2/cP', 'Pa2/(Pa.s)', 0, 19.78667553847073168648286025, 4.162314256e-10, 0],
  ['Btu[IT]/(h.ft3)', 'W/m3', 0, 1055.05585262, 101.9406477312, 0],
  ['Btu[IT]/(s.ft3)', 'W/m3', 0, 1055.05585262, 0.028316846592, 0],
  ['cal[th]/(h.cm3)', 'W/m3', 0, 4.184, 3.6e-3, 0],
  ['cal[th]/(s.cm3)', 'W/m3', 0, 4.184e6, 1, 0],
  ['hp/ft3', 'W/m3', 0, 745.69987158227022, 0.028316846592, 0],
  ['kW/m3', 'W/m3', 0, 1e3, 1, 0],
  ['uW/m3', 'W/m3', 0, 1e-6, 1, 0],
  ['kg/mol'],
  ['g/mol', 'kg/mol', 0, 1e-3, 1, 0],
  ['lbm/lbmol', 'kg/mol', 0, 1e-3, 1, 0],
  ['W/(m2.sr)'],
  ['kg/s'],
  ['1E6 lbm/a', 'kg/s', 0, 4.5359237e5, 3.15576e7, 0],
  ['g/s', 'kg/s', 0, 1e-3, 1, 0],
  ['kg/d', 'kg/s', 0, 1, 86400, 0],
  ['kg/h', 'kg/s', 0, 1, 3600, 0],
  ['kg/min', 'kg/s', 0, 1, 60, 0],
  ['lbm/d', 'kg/s', 0, 0.45359237, 8.64e4, 0],
  ['lbm/h', 'kg/s', 0, 0.45359237, 3600, 0],
  ['lbm/min', 'kg/s', 0, 0.45359237, 60, 0],
  ['lbm/s', 'kg/s', 0, 0.45359237, 1, 0],
  ['Mg/a', 'kg/s', 0, 1000, 3.15576e7, 0],
  ['Mg/d', 'kg/s', 0, 1000, 86400, 0],
  ['Mg/h', 'kg/s', 0, 1000, 3600, 0],
  ['Mg/min', 'kg/s', 0, 1000, 60, 0],
  ['t/a', 'kg/s', 0, 1000, 3.15576e7, 0],
  ['t/d', 'kg/s', 0, 1000, 86400, 0],
  ['t/h', 'kg/s', 0, 1000, 3600, 0],
  ['t/min', 'kg/s', 0, 1000, 60, 0],
  ['ton[UK]/a', 'kg/s', 0, 1016.0469088, 3.15576e7, 0],
  ['ton[UK]/d', 'kg/s', 0, 1016.0469088, 86400, 0],
  ['ton[UK]/h', 'kg/s', 0, 1016.0469088, 3600, 0],
  ['ton[UK]/min', 'kg/s', 0, 1016.0469088, 60, 0],
  ['ton[US]/a', 'kg/s', 0, 907.18474, 3.15576e7, 0],
  ['ton[US]/d', 'kg/s', 0, 907.18474, 86400, 0],
  ['ton[US]/h', 'kg/s', 0, 907.18474, 3600, 0],
  ['ton[US]/min', 'kg/s', 0, 907.18474, 60, 0],
  ['J/m2'],
  ['N/m'],
  ['erg/cm2', 'J/m2', 0, 1e-3, 1, 0],
  ['J/cm2', 'J/m2', 0, 1e4, 1, 0],
  ['kgf.m/cm2', 'J/m2', 0, 98066.5, 1, 0],
  ['lbf.ft/in2', 'J/m2', 0, 1.3558179483314004, 6.4516e-4, 0],
  ['mJ/cm2', 'J/m2', 0, 10, 1, 0],
  ['mJ/m2', 'J/m2', 0, 1e-3, 1, 0],
  ['0.01 lbf/ft', 'N/m', 0, 4.4482216152605, 30.48, 0],
  ['1/30 lbf/m', 'N/m', 0, 4.4482216152605, 30, 0],
  ['1/30 N/m', 'N/m', 0, 1, 30, 0],
  ['dyne/cm', 'N/m', 0, 1e-3, 1, 0],
  ['kgf/cm', 'N/m', 0, 980.665, 1, 0],
  ['kN/m', 'N/m', 0, 1e3, 1, 0],
  ['lbf/ft', 'N/m', 0, 4.4482216152605, 0.3048, 0],
  ['lbf/in', 'N/m', 0, 4.4482216152605, 0.0254, 0],
  ['mN/km', 'N/m', 0, 1e-6, 1, 0],
  ['mN/m', 'N/m', 0, 1e-3, 1, 0],
  ['pdl/cm', 'N/m', 0, 0.138254954376, 0.01, 0],
  ['tonf[UK]/ft', 'N/m', 0, 9964.01641818352, 0.3048, 0],
  ['tonf[US]/ft', 'N/m', 0, 8896.443230521, 0.3048, 0],
  ['W/m2'],
  ['Btu[IT]/(h.ft2)', 'W/m2', 0, 1055.05585262, 334.450944, 0],
  ['Btu[IT]/(s.ft2)', 'W/m2', 0, 1055.05585262, 0.09290304, 0],
  ['cal[th]/(h.cm2)', 'W/m2', 0, 4.184, 0.36, 0],
  ['hp/in2', 'W/m2', 0, 745.69987158227022, 6.4516e-4, 0],
  ['hp[hyd]/in2', 'W/m2', 0, 746.043, 6.4516e-4, 0],
  ['kW/cm2', 'W/m2', 0, 1e7, 1, 0],
  ['kW/m2', 'W/m2', 0, 1e3, 1, 0],
  ['mW/m2', 'W/m2', 0, 1e-3, 1, 0],
  ['ucal[th]/(s.cm2)', 'W/m2', 0, 0.04184, 1, 0],
  ['W/cm2', 'W/m2', 0, 1e4, 1, 0],
  ['W/mm2', 'W/m2', 0, 1e6, 1, 0],
  ['GPa2', 'Pa2', 0, 1e18, 1, 0],
  ['kPa2', 'Pa2', 0, 1e6, 1, 0],
  ['kpsi2', 'Pa2', 0, 1.978667553847073168648286025e7, 4.162314256e-7, 0],
  ['Pa2'],
  ['bar2', 'Pa2', 0, 1e10, 1, 0],
  ['psi2', 'Pa2', 0, 19.78667553847073168648286025, 4.162314256e-7, 0],
  ['mol'],
  ['lbmol', 'mol', 0, 453.59237, 1, 0],
  ['kmol', 'mol', 0, 1e3, 1, 0],
  ['mmol', 'mol', 0, 1e-3, 1, 0],
  ['umol', 'mol', 0, 1e-6, 1, 0],
  ['mol/m2'],
  ['mol/(s.m2)'],
  ['lbmol/(h.ft2)', 'mol/(s.m2)', 0, 453.59237, 334.450944, 0],
  ['lbmol/(s.ft2)', 'mol/(s.m2)', 0, 453.59237, 0.09290304, 0],
  ['mol/m3'],
  ['kmol/m3', 'mol/m3', 0, 1e3, 1, 0],
  ['lbmol/ft3', 'mol/m3', 0, 453.59237, 0.028316846592, 0],
  ['lbmol/gal[UK]', 'mol/m3', 0, 453.59237, 4.54609e-3, 0],
  ['lbmol/gal[US]', 'mol/m3', 0, 453.59237, 3.785411784e-3, 0],
  ['mol/s'],
  ['kmol/h', 'mol/s', 0, 1e3, 3600, 0],
  ['kmol/s', 'mol/s', 0, 1e3, 1, 0],
  ['lbmol/h', 'mol/s', 0, 453.59237, 3600, 0],
  ['lbmol/s', 'mol/s', 0, 453.59237, 1, 0],
  ['sr'],
  ['s'],
  ['a', 's', 0, 3.15576e7, 1, 0],
  ['a[t]', 's', 0, 3.1556925445e7, 1, 0],
  ['d', 's', 0, 86400, 1, 0],
  ['h', 's', 0, 3600, 1, 0],
  ['min', 's', 0, 60, 1, 0],
  ['wk', 's', 0, 6.048e5, 1, 0],
  ['1/2 ms', 's', 0, 5e-4, 1, 0],
  ['100 ka[t]', 's', 0, 3.1556925445e12, 1, 0],
  ['ca', 's', 0, 3.15576e5, 1, 0],
  ['cs', 's', 0, 0.01, 1, 0],
  ['ds', 's', 0, 0.1, 1, 0],
  ['Ea[t]', 's', 0, 3.1556925445e25, 1, 0],
  ['fa', 's', 0, 3.15576e-8, 1, 0],
  ['Ga[t]', 's', 0, 3.1556925445e16, 1, 0],
  ['hs', 's', 0, 100, 1, 0],
  ['ka[t]', 's', 0, 3.1556925445e10, 1, 0],
  ['Ma[t]', 's', 0, 3.1556925445e13, 1, 0],
  ['ms', 's', 0, 1e-3, 1, 0],
  ['na', 's', 0, 0.0315576, 1, 0],
  ['ns', 's', 0, 1e-9, 1, 0],
  ['ps', 's', 0, 1e-12, 1, 0],
  ['Ta[t]', 's', 0, 3.1556925445e19, 1, 0],
  ['us', 's', 0, 1e-6, 1, 0],
  ['s/m'],
  ['0.001 h/ft', 's/m', 0, 3600, 304.8, 0],
  ['h/km', 's/m', 0, 3.6, 1, 0],
  ['min/ft', 's/m', 0, 60, 0.3048, 0],
  ['min/m', 's/m', 0, 60, 1, 0],
  ['ms/cm', 's/m', 0, 0.1, 1, 0],
  ['ms/ft', 's/m', 0, 1e-3, 0.3048, 0],
  ['ms/in', 's/m', 0, 1e-3, 0.0254, 0],
  ['ms/m', 's/m', 0, 1e-3, 1, 0],
  ['ns/ft', 's/m', 0, 1e-9, 0.3048, 0],
  ['ns/m', 's/m', 0, 1e-9, 1, 0],
  ['s/cm', 's/m', 0, 100, 1, 0],
  ['s/ft', 's/m', 0, 1, 0.3048, 0],
  ['s/in', 's/m', 0, 1, 0.0254, 0],
  ['us/ft', 's/m', 0, 1e-6, 0.3048, 0],
  ['us/in', 's/m', 0, 1e-6, 0.0254, 0],
  ['us/m', 's/m', 0, 1e-6, 1, 0],
  ['s/m3'],
  ['0.001 d/ft3', 's/m3', 0, 86400, 28.316846592, 0],
  ['d/bbl', 's/m3', 0, 86400, 0.158987294928, 0],
  ['d/ft3', 's/m3', 0, 86400, 0.028316846592, 0],
  ['d/m3', 's/m3', 0, 86400, 1, 0],
  ['h/ft3', 's/m3', 0, 3600, 0.028316846592, 0],
  ['h/m3', 's/m3', 0, 3600, 1, 0],
  ['s/ft3', 's/m3', 0, 1, 0.028316846592, 0],
  ['s/L', 's/m3', 0, 1e3, 1, 0],
  ['s/qt[UK]', 's/m3', 0, 1, 1.1365225e-3, 0],
  ['s/qt[US]', 's/m3', 0, 1, 9.46352946e-4, 0],
  ['s/kg'],
  ['kg/J'],
  ['kg/(kW.h)', 'kg/J', 0, 1, 3.6e6, 0],
  ['kg/MJ', 'kg/J', 0, 1e-6, 1, 0],
  ['lbm/(hp.h)', 'kg/J', 0, 0.45359237, 2.684519537696172792e6, 0],
  ['mg/J', 'kg/J', 0, 1e-6, 1, 0],
  ['1/lbf', '1/N', 0, 1, 4.4482216152605, 0],
  ['1/N'],
  ['B'],
  ['dAMath.PI'],
  ['gAMath.PI'],
  ['nAMath.PI'],
  ['O'],
  ['dB.mW', 'B.W', 0, 1e-4, 1, 0],
  ['dB.MW', 'B.W', 0, 1e5, 1, 0],
  ['dB.W', 'B.W', 0, 0.1, 1, 0],
  ['dB/ft', 'B/m', 0, 0.1, 0.3048, 0],
  ['dB/km', 'B/m', 0, 1e-4, 1, 0],
  ['dB/m', 'B/m', 0, 0.1, 1, 0],
  ['dB/O', 'B/O', 0, 0.1, 1, 0],
  ['B.W'],
  ['B/m'],
  ['B/O'],
  ['V/B'],
  ['V/dB', 'V/B', 0, 10, 1, 0],
  ['dB', 'B', 0, 0.1, 1, 0],
];
